webpackJsonp([1],Array(269).concat([
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(299),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 270 */
/***/ (function(module, exports) {

module.exports = {"name":"dapnet-web","version":"2.0.0","description":"The default DAPNET Web-frontend.","author":"Marvin Menzerath","private":true,"scripts":{"dev":"node build/dev-server.js","start":"node build/dev-server.js","build":"node build/build.js","lint":"eslint --ext .js,.vue src"},"dependencies":{"chart.js":"2.5.0","font-awesome":"4.7.0","sweetalert2":"6.6.3","vue":"2.3.3","vue-chartjs":"2.6.3","vue-konami-code":"1.0.0","vue-multiselect":"2.0.0-beta.15","vue-resource":"1.3.1","vue-router":"2.5.3","vue2-leaflet":"0.0.49","vuex":"2.3.1","vuex-persistedstate":"1.4.1"},"devDependencies":{"autoprefixer":"7.1.0","babel-core":"6.24.1","babel-eslint":"7.2.3","babel-loader":"7.0.0","babel-plugin-transform-runtime":"6.23.0","babel-preset-env":"1.4.0","babel-preset-stage-2":"6.24.1","babel-register":"6.24.1","chalk":"1.1.3","connect-history-api-fallback":"1.3.0","copy-webpack-plugin":"4.0.1","css-loader":"0.28.1","eslint":"3.19.0","eslint-config-standard":"7.1.0","eslint-friendly-formatter":"3.0.0","eslint-loader":"1.7.1","eslint-plugin-html":"2.0.3","eslint-plugin-promise":"3.5.0","eslint-plugin-standard":"3.0.1","eventsource-polyfill":"0.9.6","expose-loader":"0.7.3","express":"4.15.2","extract-text-webpack-plugin":"2.1.0","file-loader":"0.11.1","friendly-errors-webpack-plugin":"1.6.1","function-bind":"1.1.0","html-webpack-plugin":"2.28.0","http-proxy-middleware":"0.17.4","opn":"5.0.0","optimize-css-assets-webpack-plugin":"1.3.1","ora":"1.2.0","rimraf":"2.6.1","semver":"5.3.0","shelljs":"0.7.7","url-loader":"0.5.8","vue-loader":"12.0.4","vue-style-loader":"3.0.1","vue-template-compiler":"2.3.3","webpack":"2.5.1","webpack-bundle-analyzer":"2.8.1","webpack-dev-middleware":"1.10.2","webpack-hot-middleware":"2.18.0","webpack-merge":"4.1.0"},"engines":{"node":">= 4.0.0","npm":">= 3.0.0"},"browserslist":["> 1%","last 2 versions","not ie <= 8"]}

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var GlobalMethodsPlugin = {
	install: function install(Vue) {
		Vue.prototype.$dialogs = {};

		Vue.prototype.$dialogs.deleteElement = function (context, workFunction) {
			context.$swal({
				title: 'Are you sure?',
				text: 'You will not be able to recover this data once it is deleted.',
				type: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#DD6B55',
				confirmButtonText: 'Yes',
				cancelButtonText: 'Cancel'
			}).then(workFunction).catch(context.$swal.noop);
		};

		Vue.prototype.$dialogs.ajaxError = function (context, err) {
			if (err.status === 0) {
				context.$swal({
					title: 'No Connection',
					html: 'Unable to reach API server. Please try again later.',
					type: 'error'
				});
			} else if (err.status === 400) {
				var errorText = err.body.message + ':<br/>';
				if (err.body.code === 4001) {
					var jsonErrors = '<ul style="text-align:left">';
					err.body.violations.forEach(function (violation) {
						jsonErrors += '<li>' + violation.field + ' ' + violation.message + ' (' + violation.code + ' - ' + violation.constraint + ')</li>';
					});
					errorText += '</ul><br />' + jsonErrors;
				}

				context.$swal({
					title: err.body.name + ' (' + err.body.code + ')',
					html: errorText,
					type: 'error'
				});
			} else if (err.status === 403) {
				context.$swal({
					title: 'Forbidden',
					html: 'No permission for this request',
					type: 'error'
				});
			} else if (err.status === 404) {
				context.$swal({
					title: 'Not Found',
					html: 'Unable to find the requested resource.',
					type: 'error'
				});
			} else {
				context.$swal({
					title: 'General Error',
					html: 'Encountered HTTP error code ' + err.status + '.',
					type: 'error'
				});
			}
		};

		Vue.prototype.$helpers = {};

		Vue.prototype.$helpers.getAjaxErrorMessage = function (response) {
			if (response.status === 0) {
				return 'Unable to reach API server. Please try again later.';
			} else if (response.status === 401 || response.status === 403) {
				return 'Invalid login credentials or no permission for this request. Please check username and password.';
			} else {
				return 'Unhandled HTTP error (' + response.status + '). Please try again later.';
			}
		};

		Vue.prototype.$helpers.checkForInput = function (context, form) {
			for (var key in form) {
				if (form.hasOwnProperty(key)) {
					if (form[key].length === 0 || form[key] === '') {
						context.$swal({
							title: 'Missing input',
							html: 'Please fill in every field to continue.',
							type: 'error'
						});
						return false;
					}
				}
			}
			return true;
		};

		Vue.prototype.$helpers.zeroPad = function (number, size) {
			var s = String(number);
			while (s.length < (size || 2)) {
				s = '0' + s;
			}
			return s;
		};

		Vue.prototype.$helpers.stringToColor = function (string) {
			var hash = 0;
			for (var i = 0; i < string.length; i++) {
				hash = string.charCodeAt(i) + ((hash << 5) - hash);
				hash = hash & hash;
			}

			return 'hsl(' + hash % 360 + ', 100%, 30%)';
		};
	}
};

/* harmony default export */ __webpack_exports__["a"] = (GlobalMethodsPlugin);

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_call_Overview__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_call_Overview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_call_Overview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_call_New__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_call_New___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_call_New__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_callsign_Overview__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_callsign_Overview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_callsign_Overview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_callsign_New__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_callsign_New___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_callsign_New__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_news_Overview__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_news_Overview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_news_Overview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_news_New__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_news_New___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_news_New__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_rubric_Overview__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_rubric_Overview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_rubric_Overview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_rubric_New__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_rubric_New___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_rubric_New__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_rubric_Activation__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_rubric_Activation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_rubric_Activation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_transmitter_Overview__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_transmitter_Overview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_transmitter_Overview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_transmitter_New__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_transmitter_New___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_transmitter_New__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_transmitter_Map__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_transmitter_Map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_transmitter_Map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_transmitter_group_Overview__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_transmitter_group_Overview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_transmitter_group_Overview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_transmitter_group_New__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_transmitter_group_New___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_transmitter_group_New__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_node_Overview__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_node_Overview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_node_Overview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_node_New__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_node_New___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_node_New__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_user_Overview__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_user_Overview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_user_Overview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_user_New__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_user_New___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_user_New__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_authentication_Login__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_authentication_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_authentication_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_authentication_Logout__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_authentication_Logout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_authentication_Logout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_VersionCheck__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_VersionCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_VersionCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_pages_Impress__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_pages_Impress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_pages_Impress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_pages_Privacy__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_pages_Privacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_pages_Privacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_pages_NotFound__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_pages_NotFound___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_pages_NotFound__);




























__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
	routes: [{
		path: '/',
		name: 'Home',
		component: __WEBPACK_IMPORTED_MODULE_2__components_Home___default.a,
		meta: {
			requireAuthentication: false
		}
	}, {
		path: '/calls',
		name: 'Call Overview',
		component: __WEBPACK_IMPORTED_MODULE_3__components_call_Overview___default.a,
		meta: {
			requireAuthentication: true
		}
	}, {
		path: '/calls/new',
		name: 'New Call',
		component: __WEBPACK_IMPORTED_MODULE_4__components_call_New___default.a,
		meta: {
			requireAuthentication: true
		}
	}, {
		path: '/callsigns',
		name: 'Callsign Overview',
		component: __WEBPACK_IMPORTED_MODULE_5__components_callsign_Overview___default.a,
		meta: {
			requireAuthentication: true
		}
	}, {
		path: '/callsigns/new',
		name: 'New Callsign',
		component: __WEBPACK_IMPORTED_MODULE_6__components_callsign_New___default.a,
		meta: {
			requireAuthentication: true
		}
	}, {
		path: '/callsigns/edit/:id',
		name: 'Edit Callsign',
		component: __WEBPACK_IMPORTED_MODULE_6__components_callsign_New___default.a,
		meta: {
			requireAuthentication: true
		}
	}, {
		path: '/news',
		name: 'News Overview',
		component: __WEBPACK_IMPORTED_MODULE_7__components_news_Overview___default.a,
		meta: {
			requireAuthentication: true
		}
	}, {
		path: '/news/new',
		name: 'New News',
		component: __WEBPACK_IMPORTED_MODULE_8__components_news_New___default.a,
		meta: {
			requireAuthentication: true
		}
	}, {
		path: '/rubrics',
		name: 'Rubric Overview',
		component: __WEBPACK_IMPORTED_MODULE_9__components_rubric_Overview___default.a,
		meta: {
			requireAuthentication: true
		}
	}, {
		path: '/rubrics/new',
		name: 'New Rubric',
		component: __WEBPACK_IMPORTED_MODULE_10__components_rubric_New___default.a,
		meta: {
			requireAuthentication: true
		}
	}, {
		path: '/rubrics/edit/:id',
		name: 'Edit Rubric',
		component: __WEBPACK_IMPORTED_MODULE_10__components_rubric_New___default.a,
		meta: {
			requireAuthentication: true
		}
	}, {
		path: '/rubrics/activate',
		name: 'Activate Rubric',
		component: __WEBPACK_IMPORTED_MODULE_11__components_rubric_Activation___default.a,
		meta: {
			requireAuthentication: true
		}
	}, {
		path: '/transmitters',
		name: 'Transmitter Overview',
		component: __WEBPACK_IMPORTED_MODULE_12__components_transmitter_Overview___default.a,
		meta: {
			requireAuthentication: true
		}
	}, {
		path: '/transmitters/new',
		name: 'New Transmitter',
		component: __WEBPACK_IMPORTED_MODULE_13__components_transmitter_New___default.a,
		meta: {
			requireAuthentication: true
		}
	}, {
		path: '/transmitters/edit/:id',
		name: 'Edit Transmitter',
		component: __WEBPACK_IMPORTED_MODULE_13__components_transmitter_New___default.a,
		meta: {
			requireAuthentication: true
		}
	}, {
		path: '/transmitters/map',
		name: 'Transmitter Map',
		component: __WEBPACK_IMPORTED_MODULE_14__components_transmitter_Map___default.a,
		meta: {
			requireAuthentication: true
		}
	}, {
		path: '/transmitters/groups',
		name: 'Transmitter Group Overview',
		component: __WEBPACK_IMPORTED_MODULE_15__components_transmitter_group_Overview___default.a,
		meta: {
			requireAuthentication: true
		}
	}, {
		path: '/transmitters/groups/new',
		name: 'New Transmitter Group',
		component: __WEBPACK_IMPORTED_MODULE_16__components_transmitter_group_New___default.a,
		meta: {
			requireAuthentication: true
		}
	}, {
		path: '/transmitters/groups/edit/:id',
		name: 'Edit Transmitter Group',
		component: __WEBPACK_IMPORTED_MODULE_16__components_transmitter_group_New___default.a,
		meta: {
			requireAuthentication: true
		}
	}, {
		path: '/nodes',
		name: 'Node Overview',
		component: __WEBPACK_IMPORTED_MODULE_17__components_node_Overview___default.a,
		meta: {
			requireAuthentication: true
		}
	}, {
		path: '/nodes/new',
		name: 'New Node',
		component: __WEBPACK_IMPORTED_MODULE_18__components_node_New___default.a,
		meta: {
			requireAuthentication: true
		}
	}, {
		path: '/nodes/edit/:id',
		name: 'Edit Node',
		component: __WEBPACK_IMPORTED_MODULE_18__components_node_New___default.a,
		meta: {
			requireAuthentication: true
		}
	}, {
		path: '/users',
		name: 'User Overview',
		component: __WEBPACK_IMPORTED_MODULE_19__components_user_Overview___default.a,
		meta: {
			requireAuthentication: true
		}
	}, {
		path: '/users/new',
		name: 'New User',
		component: __WEBPACK_IMPORTED_MODULE_20__components_user_New___default.a,
		meta: {
			requireAuthentication: true
		}
	}, {
		path: '/users/edit/:id',
		name: 'Edit User',
		component: __WEBPACK_IMPORTED_MODULE_20__components_user_New___default.a,
		meta: {
			requireAuthentication: true
		}
	}, {
		path: '/login',
		name: 'Login',
		component: __WEBPACK_IMPORTED_MODULE_21__components_authentication_Login___default.a,
		meta: {
			requireAuthentication: false
		}
	}, {
		path: '/logout',
		name: 'Logout',
		component: __WEBPACK_IMPORTED_MODULE_22__components_authentication_Logout___default.a,
		meta: {
			requireAuthentication: true
		}
	}, {
		path: '/version',
		name: 'Version Check',
		component: __WEBPACK_IMPORTED_MODULE_23__components_VersionCheck___default.a,
		meta: {
			requireAuthentication: false
		}
	}, {
		path: '/impress',
		name: 'Impress',
		component: __WEBPACK_IMPORTED_MODULE_24__components_pages_Impress___default.a,
		meta: {
			requireAuthentication: false
		}
	}, {
		path: '/privacy',
		name: 'Privacy',
		component: __WEBPACK_IMPORTED_MODULE_25__components_pages_Privacy___default.a,
		meta: {
			requireAuthentication: false
		}
	}, {
		path: '*',
		name: 'Not Found',
		component: __WEBPACK_IMPORTED_MODULE_26__components_pages_NotFound___default.a,
		meta: {
			requireAuthentication: false
		}
	}]
}));

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate__);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var defaultUrls = __webpack_require__(643);
var defaultText = __webpack_require__(642);
var defaultMap = __webpack_require__(641);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
	state: {
		url: defaultUrls,
		user: {
			name: 'Guest',
			auth: '',
			admin: false
		},
		customText: defaultText,
		map: defaultMap
	},
	getters: {
		url: function url(state) {
			return state.url;
		},
		user: function user(state) {
			return state.user;
		},
		isUserLoggedIn: function isUserLoggedIn(state) {
			return state.user.name !== 'Guest' && state.user.auth !== '';
		},
		customText: function customText(state) {
			return state.customText;
		},
		map: function map(state) {
			return state.map;
		}
	},
	mutations: {
		login: function login(state, payload) {
			state.user.name = payload.name;
			state.user.auth = payload.auth;
			state.user.admin = payload.admin;

			__WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.headers.common['Authorization'] = 'Basic ' + payload.auth;
		},
		logout: function logout(state) {
			state.user.name = 'Guest';
			state.user.auth = '';
			state.user.admin = false;

			__WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.headers.common['Authorization'] = '';
		}
	},
	plugins: [__WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate___default()({
		key: 'dapnet-web',
		paths: ['user']
	})]
}));

/***/ }),
/* 274 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 275 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 276 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 277 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 278 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 279 */,
/* 280 */,
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(418)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(290),
  /* template */
  __webpack_require__(622),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(425)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(308),
  /* template */
  __webpack_require__(629),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7d93e503",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(422)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(309),
  /* template */
  __webpack_require__(626),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7584799a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(421)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(310),
  /* template */
  __webpack_require__(625),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6922ef12",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(409)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(311),
  /* template */
  __webpack_require__(613),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2f7ff32c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(404)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(312),
  /* template */
  __webpack_require__(608),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1f08ac4c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 287 */,
/* 288 */,
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_css_fonts_css__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_css_fonts_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_css_fonts_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_font_awesome_css_font_awesome_min_css__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_font_awesome_css_font_awesome_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_font_awesome_css_font_awesome_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_multiselect_dist_vue_multiselect_min_css__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_multiselect_dist_vue_multiselect_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_multiselect_dist_vue_multiselect_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert2_dist_sweetalert2_css__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_sweetalert2_dist_sweetalert2_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_css_custom_css__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_css_custom_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_css_custom_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_resource__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_multiselect__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert2__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__global__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_konami_code__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_konami_code___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_konami_code__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_partials_Navigation__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_partials_Navigation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_partials_Navigation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_partials_TableGrid__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_partials_TableGrid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_partials_TableGrid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_partials_ActionButtons__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_partials_ActionButtons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_partials_ActionButtons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_partials_InfoError__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_partials_InfoError___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_partials_InfoError__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_partials_Footer__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_partials_Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_partials_Footer__);














__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_resource__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('multiselect', __WEBPACK_IMPORTED_MODULE_10_vue_multiselect___default.a);


var swalPlugin = {};
swalPlugin.install = function (Vue) {
	Vue.prototype.$swal = __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default.a;
};
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(swalPlugin);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12__global__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13_vue_konami_code___default.a, { callback: function callback() {
		__WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
			title: 'DAPNET Web',
			html: '<i class="fa fa-code" aria-hidden="true" style="color: #607D8B"></i> with ' + '<i class="fa fa-heart" aria-hidden="true" style="color: #F44336"></i> &amp; ' + '<i class="fa fa-coffee" aria-hidden="true" style="color: #795548"></i> in Aachen'
		});
	} });


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('app-navigation', __WEBPACK_IMPORTED_MODULE_14__components_partials_Navigation___default.a);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('tablegrid', __WEBPACK_IMPORTED_MODULE_15__components_partials_TableGrid___default.a);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('action-buttons', __WEBPACK_IMPORTED_MODULE_16__components_partials_ActionButtons___default.a);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('info-error', __WEBPACK_IMPORTED_MODULE_17__components_partials_InfoError___default.a);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('app-footer', __WEBPACK_IMPORTED_MODULE_18__components_partials_Footer___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].beforeEach(function (to, from, next) {
	if (!__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.isUserLoggedIn && to.meta.requireAuthentication) {
		next('/');
		return true;
	}

	next();
});

__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].afterEach(function (to, from) {
	document.title = to.name + ' | DAPNET';
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.options.root = __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.url.api;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.options.timeout = 10000;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.headers.common['Authorization'] = 'Basic ' + __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.user.auth;
delete __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.headers.common['Content-Type'];

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
	el: '#app',
	router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
	store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
	template: '<App/>',
	components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 290 */
/***/ (function(module, exports) {



/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	created: function created() {
		this.loadData();
	},
	data: function data() {
		return {
			stats: {
				errorMessage: false,
				running: false,
				data: false
			}
		};
	},

	computed: {
		statTransmitter: function statTransmitter() {
			return this.stats.data.transmittersOnline + ' / ' + this.stats.data.transmittersTotal;
		},
		statNodes: function statNodes() {
			return this.stats.data.nodesOnline + ' / ' + this.stats.data.nodesTotal;
		}
	},
	methods: {
		loadData: function loadData() {
			var _this = this;

			this.stats.running = true;
			this.$http.get('stats').then(function (response) {
				_this.stats.data = response.body;
				_this.stats.running = false;
				_this.stats.errorMessage = false;
			}, function (response) {
				_this.stats.running = false;

				if (response.status === 0) {
					_this.stats.errorMessage = 'Unable to reach API server. Please try again later.';
				} else {
					_this.stats.errorMessage = 'Unhandled HTTP error (' + response.status + '). Please try again later.';
				}
			});
		}
	}
});

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	created: function created() {
		var _this = this;

		var pkg = __webpack_require__(270);
		this.version.web = pkg.version;

		this.$http.get('core/version').then(function (response) {
			_this.version.core = response.body.core;
			_this.version.api = response.body.api;

			var queryString = '?core=' + _this.version.core + '&api=' + _this.version.api + '&web=' + _this.version.web;

			_this.$http.get(_this.$store.getters.url.update + queryString, {
				before: function before(request) {
					request.headers.delete('Authorization');
				}
			}).then(function (response) {
				_this.displayData = response.body;
				_this.running = false;
			}, function (response) {
				if (response.status === 0) {
					_this.errorMessage = 'Unable to find update-server. Please try again later.';
				} else {
					_this.errorMessage = 'Unable to find update-information. Please try again later.';
				}
				_this.running = false;
			});
		}, function (response) {
			if (response.status === 0) {
				_this.errorMessage = 'Unable to reach API server. Please try again later.';
			}
		});
	},
	data: function data() {
		return {
			version: {
				core: 'UNKNOWN',
				api: 'UNKNOWN',
				web: 'UNKNOWN'
			},
			displayData: '',
			errorMessage: ''
		};
	}
});

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	created: function created() {
		if (this.$store.getters.isUserLoggedIn) {
			this.$router.push('/');
		}
	},
	data: function data() {
		return {
			errorMessage: '',
			username: '',
			password: ''
		};
	},

	methods: {
		submitForm: function submitForm(event) {
			var _this = this;

			event.preventDefault();

			this.$http.get('users/' + this.username, {
				headers: {
					Authorization: 'Basic ' + btoa(this.username + ':' + this.password)
				}
			}).then(function (response) {
				_this.$store.commit('login', {
					name: response.body.name,
					auth: btoa(_this.username + ':' + _this.password),
					admin: response.body.admin
				});

				_this.$router.push('/');
			}, function (response) {
				_this.errorMessage = _this.$helpers.getAjaxErrorMessage(response);
			});
		}
	}
});

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	created: function created() {
		this.$store.commit('logout');
		this.$router.push('/');
	}
});

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	created: function created() {
		var _this = this;

		this.$http.get('callsigns').then(function (response) {
			response.body.forEach(function (callsign) {
				_this.formData.callsigns.push({ name: callsign.name });
			});
		});

		this.$http.get('transmitterGroups').then(function (response) {
			response.body.forEach(function (transmittergroup) {
				_this.formData.transmittergroups.push({ name: transmittergroup.name });

				if (transmittergroup.name === 'all') {
					_this.form.transmittergroups.push({ name: 'all' });
				}
			});
		});
	},
	data: function data() {
		return {
			form: {
				message: this.$store.getters.user.name.toUpperCase() + ': ',
				callsigns: [],
				transmittergroups: [],
				emergency: false
			},
			formData: {
				callsigns: [],
				transmittergroups: []
			}
		};
	},

	computed: {
		messageCharsRemaining: function messageCharsRemaining() {
			return 80 - this.form.message.length;
		}
	},
	methods: {
		submitForm: function submitForm(event) {
			var _this2 = this;

			event.preventDefault();

			if (!this.$helpers.checkForInput(this, this.form)) {
				return false;
			}

			var callSignNames = [];
			this.form.callsigns.forEach(function (callsign) {
				callSignNames.push(callsign.name);
			});

			var transmitterGroupNames = [];
			this.form.transmittergroups.forEach(function (transmittergroup) {
				transmitterGroupNames.push(transmittergroup.name);
			});

			var body = {
				text: this.form.message,
				callSignNames: callSignNames,
				transmitterGroupNames: transmitterGroupNames,
				emergency: this.form.emergency
			};

			this.$http.post('calls', body).then(function (response) {
				_this2.$router.push('/calls');
			}, function (response) {
				_this2.$dialogs.ajaxError(_this2, response);
			});
		}
	}
});

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	created: function created() {
		this.loadData();
	},
	data: function data() {
		return {
			errorMessage: false,
			running: false,
			table: {
				columns: [{
					id: 'timestamp',
					title: 'Timestamp'
				}, {
					id: 'callSignNames',
					title: 'Callsigns'
				}, {
					id: 'transmitterGroupNames',
					title: 'TX Groups'
				}, {
					id: 'text',
					title: 'Message'
				}, {
					id: 'emergency',
					title: 'High Prio?'
				}, {
					id: 'ownerName',
					title: 'Owner'
				}],
				rows: false
			}
		};
	},

	computed: {
		statEmergencies: function statEmergencies() {
			return this.table.rows.filter(function (value) {
				return value.emergency;
			}).length;
		},
		statTotal: function statTotal() {
			return this.table.rows.length;
		}
	},
	methods: {
		loadData: function loadData() {
			var _this = this;

			var apiEndpoint = 'calls';
			if (!this.$store.getters.user.admin) {
				apiEndpoint = 'calls?ownerName=' + this.$store.getters.user.name;
			}

			this.running = true;
			this.$http.get(apiEndpoint).then(function (response) {

				response.body.forEach(function (call) {
					call.timestamp = new Date(call.timestamp).toLocaleString();
				});

				_this.table.rows = response.body;

				_this.running = false;
				_this.errorMessage = false;
			}, function (response) {
				_this.running = false;
				_this.errorMessage = _this.$helpers.getAjaxErrorMessage(response);
			});
		}
	}
});

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	created: function created() {
		var _this = this;

		this.$http.get('users').then(function (response) {
			response.body.forEach(function (user) {
				_this.formData.users.push({ name: user.name });
			});
		});

		if (this.$route.params.id) {
			this.$http.get('callsigns/' + this.$route.params.id).then(function (response) {
				_this.editing = true;

				var pagerNumbers = '';
				var pagerNames = '';
				response.body.pagers.forEach(function (pager) {
					pagerNumbers += _this.$helpers.zeroPad(pager.number, 7) + '\n';
					pagerNames += pager.name + '\n';
				});

				var ownerNames = [];
				response.body.ownerNames.forEach(function (owner) {
					ownerNames.push({ name: owner });
				});

				_this.form.callsign = response.body.name;
				_this.form.description = response.body.description;
				_this.form.pager.numbers = pagerNumbers.trim();
				_this.form.pager.names = pagerNames.trim();
				_this.form.owners = ownerNames;
			}, function (response) {
				_this.$router.push('/callsigns');
			});
		}
	},
	data: function data() {
		return {
			editing: false,
			form: {
				callsign: '',
				description: '',
				pager: {
					numbers: '',
					names: ''
				},
				owners: []
			},
			formData: {
				users: []
			}
		};
	},

	methods: {
		submitForm: function submitForm(event) {
			var _this2 = this;

			event.preventDefault();

			if (!this.$helpers.checkForInput(this, this.form)) {
				return false;
			}

			var pagerNumbers = this.form.pager.numbers.split('\n');
			var pagerNames = this.form.pager.names.split('\n');
			var pagers = [];
			for (var i = 0; i < pagerNumbers.length; i++) {
				var item = {};
				item.number = pagerNumbers[i];
				item.name = pagerNames[i];

				pagers.push(item);
			}

			var ownerNames = [];
			this.form.owners.forEach(function (owner) {
				ownerNames.push(owner.name);
			});

			var body = {
				description: this.form.description,
				pagers: pagers,
				ownerNames: ownerNames
			};

			this.$http.put('callsigns/' + this.form.callsign, body).then(function (response) {
				_this2.$router.push('/callsigns');
			}, function (response) {
				_this2.$dialogs.ajaxError(_this2, response);
			});
		}
	}
});

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	created: function created() {
		this.loadData();
	},
	data: function data() {
		return {
			errorMessage: false,
			running: false,
			table: {
				columns: [{
					id: 'name',
					title: 'Callsign'
				}, {
					id: 'description',
					title: 'Description'
				}, {
					id: 'pagers',
					title: 'Pager'
				}, {
					id: 'ownerNames',
					title: 'Owner'
				}, {
					id: 'actions',
					title: 'Actions'
				}],
				rows: false
			}
		};
	},

	computed: {
		statTotal: function statTotal() {
			return this.table.rows.length;
		}
	},
	methods: {
		loadData: function loadData() {
			var _this = this;

			this.running = true;
			this.$http.get('callsigns').then(function (response) {

				response.body.forEach(function (callsign) {
					if (_this.$store.getters.user.admin) {
						var pagerText = [];
						callsign.pagers.forEach(function (pager) {
							return pagerText.push(pager.name + ' (' + _this.$helpers.zeroPad(pager.number, 7) + ')');
						});
						callsign.pagers = pagerText.join(', ');
					} else {
						callsign.pagers = '---';
					}

					callsign.actions = false;
					if (_this.$store.getters.user.admin || callsign.ownerNames.includes(_this.$store.getters.user.name)) {
						callsign.actions = true;
					}
				});

				_this.table.rows = response.body;

				_this.running = false;
				_this.errorMessage = false;
			}, function (response) {
				_this.running = false;
				_this.errorMessage = _this.$helpers.getAjaxErrorMessage(response);
			});
		},
		editElement: function editElement(element) {
			this.$router.push({ name: 'Edit Callsign', params: { id: element.name } });
		},
		deleteElement: function deleteElement(element) {
			var _this2 = this;

			this.$dialogs.deleteElement(this, function () {
				_this2.$http.delete('callsigns/' + element.name, {
					before: function before(request) {
						request.headers.delete('Content-Type');
					}
				}).then(function (response) {
					_this2.loadData();
				}, function (response) {
					_this2.$dialogs.ajaxError(_this2, response);
				});
			});
		}
	}
});

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__);



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["Pie"].extend({
	mixins: [__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["mixins"].reactiveProp],
	data: function data() {
		return {
			chartOptions: {
				responsive: true,
				legend: {
					position: 'bottom'
				}
			}
		};
	},
	mounted: function mounted() {
		this.renderChart(this.chartData, this.chartOptions);
	}
}));

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__);



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["Pie"].extend({
	mixins: [__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["mixins"].reactiveProp],
	data: function data() {
		return {
			chartOptions: {
				responsive: true,
				maintainAspectRatio: false,
				legend: {
					position: 'bottom'
				}
			}
		};
	},
	mounted: function mounted() {
		this.renderChart(this.chartData, this.chartOptions);
	}
}));

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	created: function created() {
		var _this = this;

		this.$http.get('rubrics').then(function (response) {
			response.body.forEach(function (rubric) {
				_this.formData.rubrics.push({ name: rubric.name });
			});
		});
	},
	data: function data() {
		return {
			form: {
				message: '',
				rubric: '',
				numberNext: true,
				number: 1
			},
			formData: {
				rubrics: []
			}
		};
	},

	computed: {
		messageCharsRemaining: function messageCharsRemaining() {
			return 80 - this.form.message.length;
		}
	},
	methods: {
		submitForm: function submitForm(event) {
			var _this2 = this;

			event.preventDefault();

			if (!this.$helpers.checkForInput(this, this.form)) {
				return false;
			}

			var body = {
				text: this.form.message,
				rubricName: this.form.rubric.name,
				number: this.form.number
			};

			if (this.form.numberNext) {
				body.number = 0;
			}

			this.$http.post('news/', body).then(function (response) {
				_this2.$router.push('/news');
			}, function (response) {
				_this2.$dialogs.ajaxError(_this2, response);
			});
		}
	}
});

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);




/* harmony default export */ __webpack_exports__["default"] = ({
	created: function created() {
		this.loadData();
	},
	data: function data() {
		return {
			errorMessage: false,
			running: false,
			table: {
				columns: [{
					id: 'timestamp',
					title: 'Timestamp'
				}, {
					id: 'rubricName',
					title: 'Rubric'
				}, {
					id: 'number',
					title: '#'
				}, {
					id: 'text',
					title: 'Message'
				}, {
					id: 'ownerName',
					title: 'Owner'
				}],
				rows: false
			}
		};
	},

	computed: {
		statTotal: function statTotal() {
			return this.table.rows.length;
		}
	},
	methods: {
		loadData: function loadData() {
			var _this = this;

			this.running = true;
			this.$http.get('news').then(function (response) {
				var data = [];
				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;

				try {
					for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(response.body)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
						var key = _step.value;
						var _iteratorNormalCompletion2 = true;
						var _didIteratorError2 = false;
						var _iteratorError2 = undefined;

						try {
							for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(response.body[key]), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
								var news = _step2.value;

								if (news !== null) {
									news.timestamp = new Date(news.timestamp).toLocaleString();
									data.push(news);
								}
							}
						} catch (err) {
							_didIteratorError2 = true;
							_iteratorError2 = err;
						} finally {
							try {
								if (!_iteratorNormalCompletion2 && _iterator2.return) {
									_iterator2.return();
								}
							} finally {
								if (_didIteratorError2) {
									throw _iteratorError2;
								}
							}
						}
					}
				} catch (err) {
					_didIteratorError = true;
					_iteratorError = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}
					} finally {
						if (_didIteratorError) {
							throw _iteratorError;
						}
					}
				}

				_this.table.rows = data;

				_this.running = false;
				_this.errorMessage = false;
			}, function (response) {
				_this.running = false;
				_this.errorMessage = _this.$helpers.getAjaxErrorMessage(response);
			});
		}
	}
});

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	created: function created() {
		var _this = this;

		this.$http.get('users').then(function (response) {
			response.body.forEach(function (user) {
				_this.formData.users.push({ name: user.name });
			});
		});

		if (this.$route.params.id) {
			this.$http.get('nodes/' + this.$route.params.id).then(function (response) {
				_this.editing = true;

				var ownerNames = [];
				response.body.ownerNames.forEach(function (owner) {
					ownerNames.push({ name: owner });
				});

				_this.form.name = response.body.name;
				_this.form.latitude.value = Math.abs(response.body.latitude);
				_this.form.latitude.orientation = response.body.latitude >= 0 ? 1 : -1;
				_this.form.longitude.value = Math.abs(response.body.longitude);
				_this.form.longitude.orientation = response.body.longitude >= 0 ? 1 : -1;
				_this.form.owners = ownerNames;
				_this.form.status = response.body.status;
			}, function (response) {
				_this.$router.push('/nodes');
			});
		}
	},
	data: function data() {
		return {
			editing: false,
			form: {
				name: '',
				latitude: {
					value: 0,
					orientation: 1
				},
				longitude: {
					value: 0,
					orientation: 1
				},
				owners: [],
				status: 'ONLINE'
			},
			formData: {
				users: []
			}
		};
	},

	methods: {
		submitForm: function submitForm(event) {
			var _this2 = this;

			event.preventDefault();

			if (!this.$helpers.checkForInput(this, this.form)) {
				return false;
			}

			if (this.form.latitude.value === '' || this.form.longitude.value === '') {
				this.$swal({
					title: 'Invalid location',
					html: 'Please check the given location and make sure to use a dot (<code>.</code>) as decimal separator.',
					type: 'error'
				});
				return false;
			}

			var ownerNames = [];
			this.form.owners.forEach(function (owner) {
				ownerNames.push(owner.name);
			});

			var body = {
				latitude: this.form.latitude.value * this.form.latitude.orientation,
				longitude: this.form.longitude.value * this.form.longitude.orientation,
				ownerNames: ownerNames,
				status: this.form.status
			};

			this.$http.put('nodes/' + this.form.name, body).then(function (response) {
				_this2.$router.push('/nodes');
			}, function (response) {
				_this2.$dialogs.ajaxError(_this2, response);
			});
		}
	}
});

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_charts_OnlineOffline__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_charts_OnlineOffline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_charts_OnlineOffline__);




/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		ChartOnlineOffline: __WEBPACK_IMPORTED_MODULE_0__components_charts_OnlineOffline___default.a
	},
	created: function created() {
		this.loadData();
	},
	data: function data() {
		return {
			errorMessage: false,
			running: false,
			table: {
				columns: [{
					id: 'name',
					title: 'Name'
				}, {
					id: 'address',
					title: 'IP-Address'
				}, {
					id: 'ownerNames',
					title: 'Owner'
				}, {
					id: 'status',
					title: 'Status'
				}, {
					id: 'actions',
					title: 'Actions'
				}],
				rows: false
			}
		};
	},

	computed: {
		chartData: function chartData() {
			var online = this.table.rows.filter(function (value) {
				return value.status.includes('ONLINE');
			}).length;

			return {
				labels: ['Online', 'Offline'],
				datasets: [{
					data: [online, this.statTotal - online],
					backgroundColor: ['#469408', '#D9230F'],
					hoverBackgroundColor: ['#469408', '#D9230F']
				}]
			};
		},
		statTotal: function statTotal() {
			return this.table.rows.length;
		}
	},
	methods: {
		loadData: function loadData() {
			var _this = this;

			this.running = true;
			this.$http.get('nodes').then(function (response) {

				response.body.forEach(function (node) {
					if (_this.$store.getters.user.admin && node.address !== null) {
						node.address = node.address.ip_addr + ':' + node.address.port;
					} else {
						node.address = '---';
					}

					if (node.status === 'ONLINE') {
						node.status = '<span class="label label-success">ONLINE</span>';
					} else if (node.status === 'SUSPENDED') {
						node.status = '<span class="label label-primary">SUSPENDED</span>';
					} else {
						node.status = '<span class="label label-warning">' + node.status + '</span>';
					}

					node.actions = false;
					if (_this.$store.getters.user.admin || node.ownerNames.includes(_this.$store.getters.user.name)) {
						node.actions = true;
					}
				});

				_this.table.rows = response.body;

				_this.running = false;
				_this.errorMessage = false;
			}, function (response) {
				_this.running = false;
				_this.errorMessage = _this.$helpers.getAjaxErrorMessage(response);
			});
		},
		mailToOwner: function mailToOwner(element) {
			var _this2 = this;

			var mailTo = [];
			this.$http.get('users').then(function (response) {
				response.body.forEach(function (user) {
					if (element.ownerNames.includes(user.name)) {
						mailTo.push(user.mail);
					}
				});
				window.location.href = 'mailto:' + mailTo.join(',') + '?subject=DAPNET%20Node%3A%20' + element.name;
			}, function (response) {
				_this2.$dialogs.ajaxError(_this2, response);
			});
		},
		editElement: function editElement(element) {
			this.$router.push({ name: 'Edit Node', params: { id: element.name } });
		},
		deleteElement: function deleteElement(element) {
			var _this3 = this;

			this.$dialogs.deleteElement(this, function () {
				_this3.$http.delete('nodes/' + element.name, {
					before: function before(request) {
						request.headers.delete('Content-Type');
					}
				}).then(function (response) {
					_this3.loadData();
				}, function (response) {
					_this3.$dialogs.ajaxError(_this3, response);
				});
			});
		},
		mailToAll: function mailToAll() {
			var _this4 = this;

			var mailTo = [];
			this.$http.get('users').then(function (response) {
				response.body.forEach(function (user) {
					_this4.table.rows.forEach(function (row) {
						if (row.ownerNames.includes(user.name) && !mailTo.includes(user.mail)) {
							mailTo.push(user.mail);
						}
					});
				});
				window.location.href = 'mailto:' + mailTo.join(',') + '?subject=DAPNET%20Node';
			}, function (response) {
				_this4.$dialogs.ajaxError(_this4, response);
			});
		}
	}
});

/***/ }),
/* 305 */
/***/ (function(module, exports) {



/***/ }),
/* 306 */
/***/ (function(module, exports) {



/***/ }),
/* 307 */
/***/ (function(module, exports) {



/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	props: {
		element: Object,
		mailAction: Function,
		editAction: Function,
		deleteAction: Function
	}
});

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	created: function created() {
		var _this = this;

		this.$http.get('core/version').then(function (response) {
			_this.version.core = response.body.core;
		});

		var pkg = __webpack_require__(270);
		this.version.web = pkg.version;
	},
	data: function data() {
		return {
			version: {
				core: 'Unknown',
				web: 'Unknown'
			}
		};
	}
});

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	props: {
		message: ''
	}
});

/***/ }),
/* 311 */
/***/ (function(module, exports) {



/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);



/* harmony default export */ __webpack_exports__["default"] = ({
	props: {
		data: Array,
		columns: Array,
		mailAction: Function,
		editAction: Function,
		deleteAction: Function
	},
	data: function data() {
		var sortOrders = {};
		this.columns.forEach(function (key) {
			sortOrders[key.id] = 1;
		});
		return {
			sortKey: '',
			sortOrders: sortOrders,
			searchQuery: '',
			gotoPage: 1,
			startRow: 0,
			rowsPerPage: 10
		};
	},

	computed: {
		filteredData: function filteredData() {
			var sortKey = this.sortKey;
			var filterKey = this.searchQuery && this.searchQuery.toLowerCase();
			var order = this.sortOrders[sortKey] || 1;
			var data = this.data;
			if (filterKey) {
				data = data.filter(function (row) {
					return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(row).some(function (key) {
						return String(row[key]).toLowerCase().includes(filterKey);
					});
				});
			}
			if (sortKey) {
				data = data.slice().sort(function (a, b) {
					if (sortKey === 'timestamp') {
						a = new Date(a[sortKey]);
						b = new Date(b[sortKey]);

						return (a === b ? 0 : a > b ? -1 : 1) * order;
					} else {
						a = a[sortKey];
						b = b[sortKey];

						return (a === b ? 0 : a > b ? 1 : -1) * order;
					}
				});
			}
			return data;
		},
		paginatedData: function paginatedData() {
			return this.filteredData.slice(this.startRow, this.startRow + this.rowsPerPage);
		},
		currentPage: function currentPage() {
			if (this.filteredData.length === 0) {
				return 0;
			} else {
				return this.startRow / this.rowsPerPage + 1;
			}
		},
		totalPages: function totalPages() {
			var total = Math.ceil(this.filteredData.length / this.rowsPerPage);
			if (total === 0) {
				total = 1;
			}
			return total;
		}
	},
	filters: {
		arrayToString: function arrayToString(v) {
			if (v instanceof Array) {
				return v.join(', ');
			} else {
				return v;
			}
		},
		booleanToString: function booleanToString(v) {
			if (v === true) {
				return 'Yes';
			} else if (v === false) {
				return 'No';
			} else {
				return v;
			}
		}
	},
	methods: {
		sortBy: function sortBy(key) {
			this.sortKey = key;
			this.sortOrders[key] = this.sortOrders[key] * -1;

			this.startRow = 0;
		},
		movePages: function movePages(v) {
			var newStartRow = this.startRow + v * this.rowsPerPage;
			if (newStartRow >= 0 && newStartRow < this.filteredData.length) {
				this.startRow = newStartRow;
			}
		}
	},
	watch: {
		currentPage: function currentPage() {
			this.gotoPage = this.currentPage;
		},
		gotoPage: function gotoPage() {
			if (this.gotoPage >= 1 && this.gotoPage <= this.totalPages) {
				this.startRow = (this.gotoPage - 1) * this.rowsPerPage;
			}
		},
		searchQuery: function searchQuery() {
			this.startRow = 0;
		}
	},
	mounted: function mounted() {
		this.sortBy(this.columns[0].id);
		this.sortBy(this.columns[0].id);
	}
});

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	created: function created() {
		var _this = this;

		this.$http.get('transmitterGroups').then(function (response) {
			response.body.forEach(function (transmittergroup) {
				_this.formData.transmittergroups.push({ name: transmittergroup.name });
			});
		});
	},
	data: function data() {
		return {
			form: {
				number: 1,
				transmittergroups: []
			},
			formData: {
				transmittergroups: []
			}
		};
	},

	methods: {
		submitForm: function submitForm(event) {
			var _this2 = this;

			event.preventDefault();

			if (!this.$helpers.checkForInput(this, this.form)) {
				return false;
			}

			var transmitterGroupNames = [];
			this.form.transmittergroups.forEach(function (transmittergroup) {
				transmitterGroupNames.push(transmittergroup.name);
			});

			var body = {
				number: this.form.number,
				transmitterGroupNames: transmitterGroupNames
			};

			this.$http.post('activation/', body).then(function (response) {
				_this2.$router.push('/rubrics');
			}, function (response) {
				_this2.$dialogs.ajaxError(_this2, response);
			});
		}
	}
});

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	created: function created() {
		var _this = this;

		this.$http.get('transmitterGroups').then(function (response) {
			response.body.forEach(function (transmittergroup) {
				_this.formData.transmittergroups.push({ name: transmittergroup.name });
			});
		});

		this.$http.get('users').then(function (response) {
			response.body.forEach(function (user) {
				_this.formData.users.push({ name: user.name });
			});
		});

		if (this.$route.params.id) {
			this.$http.get('rubrics/' + this.$route.params.id).then(function (response) {
				_this.editing = true;

				var transmitterGroupNames = [];
				response.body.transmitterGroupNames.forEach(function (transmittergroup) {
					transmitterGroupNames.push({ name: transmittergroup });
				});

				var ownerNames = [];
				response.body.ownerNames.forEach(function (owner) {
					ownerNames.push({ name: owner });
				});

				_this.form.name = response.body.name;
				_this.form.label = response.body.label;
				_this.form.number = response.body.number;
				_this.form.transmittergroups = transmitterGroupNames;
				_this.form.owners = ownerNames;
			}, function (response) {
				_this.$router.push('/rubrics');
			});
		}
	},
	data: function data() {
		return {
			editing: false,
			form: {
				name: '',
				label: '',
				number: 1,
				transmittergroups: [],
				owners: []
			},
			formData: {
				transmittergroups: [],
				users: []
			}
		};
	},

	methods: {
		submitForm: function submitForm(event) {
			var _this2 = this;

			event.preventDefault();

			if (!this.$helpers.checkForInput(this, this.form)) {
				return false;
			}

			var transmitterGroupNames = [];
			this.form.transmittergroups.forEach(function (transmittergroup) {
				transmitterGroupNames.push(transmittergroup.name);
			});

			var ownerNames = [];
			this.form.owners.forEach(function (owner) {
				ownerNames.push(owner.name);
			});

			var body = {
				label: this.form.label,
				number: this.form.number,
				transmitterGroupNames: transmitterGroupNames,
				ownerNames: ownerNames
			};

			this.$http.put('rubrics/' + this.form.name, body).then(function (response) {
				_this2.$router.push('/rubrics');
			}, function (response) {
				_this2.$dialogs.ajaxError(_this2, response);
			});
		}
	}
});

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	created: function created() {
		this.loadData();
	},
	data: function data() {
		return {
			errorMessage: false,
			running: false,
			table: {
				columns: [{
					id: 'number',
					title: 'Number'
				}, {
					id: 'name',
					title: 'Name'
				}, {
					id: 'label',
					title: 'Label'
				}, {
					id: 'transmitterGroupNames',
					title: 'Transmitter Groups'
				}, {
					id: 'ownerNames',
					title: 'Owner'
				}, {
					id: 'actions',
					title: 'Actions'
				}],
				rows: false
			}
		};
	},

	computed: {
		statTotal: function statTotal() {
			return this.table.rows.length;
		}
	},
	methods: {
		loadData: function loadData() {
			var _this = this;

			this.running = true;
			this.$http.get('rubrics').then(function (response) {

				response.body.forEach(function (rubric) {
					rubric.actions = false;
					if (_this.$store.getters.user.admin || rubric.ownerNames.includes(_this.$store.getters.user.name)) {
						rubric.actions = true;
					}
				});

				_this.table.rows = response.body;

				_this.running = false;
				_this.errorMessage = false;
			}, function (response) {
				_this.running = false;
				_this.errorMessage = _this.$helpers.getAjaxErrorMessage(response);
			});
		},
		editElement: function editElement(element) {
			this.$router.push({ name: 'Edit Rubric', params: { id: element.name } });
		},
		deleteElement: function deleteElement(element) {
			var _this2 = this;

			this.$dialogs.deleteElement(this, function () {
				_this2.$http.delete('rubrics/' + element.name, {
					before: function before(request) {
						request.headers.delete('Content-Type');
					}
				}).then(function (response) {
					_this2.loadData();
				}, function (response) {
					_this2.$dialogs.ajaxError(_this2, response);
				});
			});
		}
	}
});

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_leaflet__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_leaflet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_leaflet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_leaflet__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_leaflet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_leaflet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_leaflet_dist_leaflet_css__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_leaflet_dist_leaflet_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__node_modules_leaflet_dist_leaflet_css__);






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('v-map', __WEBPACK_IMPORTED_MODULE_1_vue2_leaflet___default.a.Map);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('v-tilelayer', __WEBPACK_IMPORTED_MODULE_1_vue2_leaflet___default.a.TileLayer);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('v-marker', __WEBPACK_IMPORTED_MODULE_1_vue2_leaflet___default.a.Marker);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('v-popup', __WEBPACK_IMPORTED_MODULE_1_vue2_leaflet___default.a.Popup);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('v-polyline', __WEBPACK_IMPORTED_MODULE_1_vue2_leaflet___default.a.Polyline);

/* harmony default export */ __webpack_exports__["default"] = ({
	created: function created() {
		this.createMap();
	},
	data: function data() {
		return {
			settings: {
				widerangeOnly: true,
				showNodes: false,
				showLines: false
			},
			zoom: this.$store.getters.map.zoom,
			center: this.$store.getters.map.center,
			attribution: '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a>',
			url: this.$store.getters.url.map,
			markers: [],
			lines: []
		};
	},

	methods: {
		createMap: function createMap() {
			var _this = this;

			var iconNodeOnline = __WEBPACK_IMPORTED_MODULE_2_leaflet___default.a.icon({
				iconUrl: './assets/img/marker-node-online.png',
				iconSize: [30, 30],
				iconAnchor: [15, 15],
				popupAnchor: [0, 0]
			});

			var iconNodeSuspended = __WEBPACK_IMPORTED_MODULE_2_leaflet___default.a.icon({
				iconUrl: './assets/img/marker-node-suspended.png',
				iconSize: [30, 30],
				iconAnchor: [15, 15],
				popupAnchor: [0, 0]
			});

			var iconNodeUnknown = __WEBPACK_IMPORTED_MODULE_2_leaflet___default.a.icon({
				iconUrl: './assets/img/marker-node-unknown.png',
				iconSize: [30, 30],
				iconAnchor: [15, 15],
				popupAnchor: [0, 0]
			});

			var iconTransmitterOnline = __WEBPACK_IMPORTED_MODULE_2_leaflet___default.a.icon({
				iconUrl: './assets/img/marker-transmitter-online.png',
				iconSize: [28, 30],
				iconAnchor: [15, 30],
				popupAnchor: [0, -25]
			});

			var iconTransmitterOffline = __WEBPACK_IMPORTED_MODULE_2_leaflet___default.a.icon({
				iconUrl: './assets/img/marker-transmitter-offline.png',
				iconSize: [28, 30],
				iconAnchor: [15, 30],
				popupAnchor: [0, -25]
			});

			this.$http.get('nodes').then(function (response) {
				var allNodes = response.body;

				var markerNodes = [];
				response.body.forEach(function (node) {
					var selectedMarkerIcon = iconNodeOnline;
					if (node.status === 'SUSPENDED') {
						selectedMarkerIcon = iconNodeSuspended;
					} else if (node.status !== 'ONLINE') {
						selectedMarkerIcon = iconNodeUnknown;
					}

					var popupIp = '';
					if (node.address !== null) {
						popupIp = '<br />IP: ' + node.address.ip_addr + ':' + node.address.port;
					}

					if (_this.settings.showNodes) {
						markerNodes.push({
							name: node.name,
							position: {
								lat: node.latitude,
								lng: node.longitude
							},
							popup: '<b>' + node.name + '</b>' + popupIp,
							icon: selectedMarkerIcon
						});
					}
				});

				_this.$http.get('transmitters').then(function (response) {
					var markerTransmitters = [];
					var polylineTransmitters = [];

					response.body.forEach(function (transmitter) {
						if (_this.settings.widerangeOnly && transmitter.usage !== 'WIDERANGE') {
							return true;
						}

						var selectedMarkerIcon = iconTransmitterOnline;
						if (transmitter.status !== 'ONLINE') {
							selectedMarkerIcon = iconTransmitterOffline;
						}

						markerTransmitters.push({
							name: transmitter.name,
							position: {
								lat: transmitter.latitude,
								lng: transmitter.longitude
							},
							popup: '<b>' + transmitter.name + '</b><br />Transmission Power (W): ' + transmitter.power + '<br />Timeslot: ' + transmitter.timeSlot,
							icon: selectedMarkerIcon
						});

						if (_this.settings.showLines && _this.settings.showNodes) {
							allNodes.forEach(function (node) {
								if (node.name === transmitter.nodeName) {
									polylineTransmitters.push({
										name: transmitter.name,
										position: [[node.latitude, node.longitude], [transmitter.latitude, transmitter.longitude]],
										color: _this.$helpers.stringToColor(node.name)
									});
								}
							});
						}
					});

					_this.markers = markerNodes.concat(markerTransmitters);
					_this.lines = polylineTransmitters;
				});
			});
		}
	},
	watch: {
		'settings.widerangeOnly': function settingsWiderangeOnly() {
			this.createMap();
		},
		'settings.showNodes': function settingsShowNodes() {
			if (!this.showNodes) {
				this.settings.showLines = false;
			}
			this.createMap();
		},
		'settings.showLines': function settingsShowLines() {
			this.createMap();
		}
	}
});

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	created: function created() {
		var _this = this;

		this.$http.get(this.$store.getters.url.hamnetDb, {
			before: function before(request) {
				request.headers.delete('Authorization');
			}
		}).then(function (response) {
			response.body.data.forEach(function (entry) {
				_this.formData.hamnetDb.all.push({
					name: entry.callsign + ' - ' + entry.name,
					callsign: entry.callsign,
					latitude: entry.latitude,
					longitude: entry.longitude
				});
			});
		});

		this.$http.get('nodes').then(function (response) {
			response.body.forEach(function (node) {
				_this.formData.nodes.push({ name: node.name });
			});
		});

		this.$http.get('users').then(function (response) {
			response.body.forEach(function (user) {
				_this.formData.users.push({ name: user.name });
			});
		});

		if (this.$route.params.id) {
			this.$http.get('transmitters/' + this.$route.params.id).then(function (response) {
				_this.editing = true;

				var timeSlot = [];
				for (var i = 0; i < response.body.timeSlot.length; i++) {
					timeSlot.push(response.body.timeSlot.charAt(i));
				}

				var ownerNames = [];
				response.body.ownerNames.forEach(function (owner) {
					ownerNames.push({ name: owner });
				});

				_this.form.name = response.body.name;
				_this.form.password = response.body.authKey;
				_this.form.node = { name: response.body.nodeName };
				_this.form.latitude.value = Math.abs(response.body.latitude);
				_this.form.latitude.orientation = response.body.latitude >= 0 ? 1 : -1;
				_this.form.longitude.value = Math.abs(response.body.longitude);
				_this.form.longitude.orientation = response.body.longitude >= 0 ? 1 : -1;
				_this.form.power = response.body.power;
				_this.form.usage = response.body.usage;
				_this.form.antennatype = response.body.antennaType;
				_this.form.antennalevel = response.body.antennaAboveGroundLevel;
				_this.form.antennadirection = response.body.antennaDirection;
				_this.form.antennagain = response.body.antennaGainDbi;
				_this.form.identificationAddress = response.body.identificationAddress;
				_this.form.timeslot = timeSlot;
				_this.form.owners = ownerNames;

				_this.form.device.type = response.body.deviceType;
				_this.form.device.version = response.body.deviceVersion;
				if (response.body.address !== null) {
					_this.form.address = response.body.address;
				}

				if (response.body.lastConnected !== null) {
					_this.form.connection.last = new Date(response.body.lastConnected).toLocaleString();
				}
				if (response.body.connectedSince !== null) {
					_this.form.connection.since = new Date(response.body.connectedSince).toLocaleString();
				}
			}, function (response) {
				_this.$router.push('/transmitters');
			});
		}
	},
	data: function data() {
		return {
			editing: false,
			form: {
				name: '',
				password: '',
				node: '',
				latitude: {
					value: 0,
					orientation: 1
				},
				longitude: {
					value: 0,
					orientation: 1
				},
				power: 0,
				usage: 'PERSONAL',
				antennatype: 'OMNI',
				antennalevel: 0,
				antennadirection: 0,
				antennagain: 0,
				identificationAddress: 1,
				timeslot: [],
				owners: [],
				device: {
					type: '',
					version: ''
				},
				address: {
					ip_addr: '',
					port: ''
				},
				connection: {
					last: '',
					since: ''
				}
			},
			formData: {
				hamnetDb: {
					all: [],
					selected: {}
				},
				nodes: [],
				users: []
			}
		};
	},

	methods: {
		submitForm: function submitForm(event) {
			var _this2 = this;

			event.preventDefault();

			if (!this.$helpers.checkForInput(this, this.form)) {
				return false;
			}

			if (this.form.latitude.value === '' || this.form.longitude.value === '') {
				this.$swal({
					title: 'Invalid location',
					html: 'Please check the given location and make sure to use a dot (<code>.</code>) as decimal separator.',
					type: 'error'
				});
				return false;
			}

			var ownerNames = [];
			this.form.owners.forEach(function (owner) {
				ownerNames.push(owner.name);
			});

			var body = {
				authKey: this.form.password,
				nodeName: this.form.node.name,
				latitude: this.form.latitude.value * this.form.latitude.orientation,
				longitude: this.form.longitude.value * this.form.longitude.orientation,
				power: this.form.power,
				usage: this.form.usage,
				antennaAboveGroundLevel: this.form.antennalevel,
				antennaType: this.form.antennatype,
				antennaDirection: this.form.antennadirection,
				antennaGainDbi: this.form.antennagain,
				identificationAddress: this.form.identificationAddress,
				timeSlot: this.form.timeslot.sort().join(''),
				ownerNames: ownerNames
			};

			this.$http.put('transmitters/' + this.form.name, body).then(function (response) {
				_this2.$router.push('/transmitters');
			}, function (response) {
				_this2.$dialogs.ajaxError(_this2, response);
			});
		}
	},
	watch: {
		'formData.hamnetDb.selected': function formDataHamnetDbSelected(val) {
			this.form.name = val.callsign;
			this.form.latitude.value = Math.abs(val.latitude).toFixed(6);
			this.form.latitude.orientation = val.latitude >= 0 ? 1 : -1;
			this.form.longitude.value = Math.abs(val.longitude).toFixed(6);
			this.form.longitude.orientation = val.longitude >= 0 ? 1 : -1;
		}
	}
});

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_charts_OnlineOffline__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_charts_OnlineOffline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_charts_OnlineOffline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_charts_TransmitterTypes__ = __webpack_require__(587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_charts_TransmitterTypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_charts_TransmitterTypes__);






/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		ChartOnlineOffline: __WEBPACK_IMPORTED_MODULE_1__components_charts_OnlineOffline___default.a, ChartTransmitterTypes: __WEBPACK_IMPORTED_MODULE_2__components_charts_TransmitterTypes___default.a
	},
	created: function created() {
		this.loadData();
	},
	data: function data() {
		return {
			errorMessage: false,
			running: false,
			table: {
				columns: [{
					id: 'name',
					title: 'Callsign'
				}, {
					id: 'nodeName',
					title: 'Node'
				}, {
					id: 'address',
					title: 'IP-Address'
				}, {
					id: 'ownerNames',
					title: 'Owner'
				}, {
					id: 'deviceType',
					title: 'Device'
				}, {
					id: 'status',
					title: 'Status'
				}, {
					id: 'actions',
					title: 'Actions'
				}],
				rows: false
			},
			settings: {
				widerangeOnly: true
			}
		};
	},

	computed: {
		statTotal: function statTotal() {
			if (this.settings.widerangeOnly) {
				return this.table.rows.filter(function (value) {
					return value.usage === 'WIDERANGE';
				}).length;
			} else {
				return this.table.rows.length;
			}
		},
		statOnline: function statOnline() {
			if (this.settings.widerangeOnly) {
				return this.table.rows.filter(function (value) {
					return value.status.includes('ONLINE') && value.usage === 'WIDERANGE';
				}).length;
			} else {
				return this.table.rows.filter(function (value) {
					return value.status.includes('ONLINE');
				}).length;
			}
		},
		chartData: function chartData() {
			return {
				labels: ['Online', 'Offline'],
				datasets: [{
					data: [this.statOnline, this.statTotal - this.statOnline],
					backgroundColor: ['#469408', '#D9230F'],
					hoverBackgroundColor: ['#469408', '#D9230F']
				}]
			};
		},
		chartDataDeviceTypes: function chartDataDeviceTypes() {
			var _this = this;

			var chartData = {
				labels: [],
				datasets: [{
					data: [],
					backgroundColor: [],
					hoverBackgroundColor: []
				}]
			};

			if (!this.table.rows || this.table.rows.length === 0) return chartData;

			var returnData = {};
			this.table.rows.forEach(function (transmitter) {
				if (!transmitter.status.includes('ONLINE')) {
					return true;
				}

				if (_this.settings.widerangeOnly && transmitter.usage !== 'WIDERANGE') {
					return true;
				}

				var deviceTypeSplitted = transmitter.deviceType.split(' ');
				var deviceType = deviceTypeSplitted[deviceTypeSplitted.length - 1];

				if (!deviceType || deviceType === '---') {
					deviceType = 'Unknown';
				}

				if (returnData[deviceType] !== undefined) {
					returnData[deviceType].amount++;
				} else {
					returnData[deviceType] = {};
					returnData[deviceType].name = deviceType;
					returnData[deviceType].amount = 1;
				}
			});

			var orderedReturnData = {};
			__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(returnData).sort().forEach(function (key) {
				orderedReturnData[key] = returnData[key];
			});

			for (var key in orderedReturnData) {
				if (!orderedReturnData.hasOwnProperty(key)) {
					return true;
				}

				chartData.labels.push(orderedReturnData[key].name);
				chartData.datasets[0].data.push(orderedReturnData[key].amount);

				var color = this.$helpers.stringToColor(orderedReturnData[key].name);
				chartData.datasets[0].backgroundColor.push(color);
				chartData.datasets[0].hoverBackgroundColor.push(color);
			}

			return chartData;
		}
	},
	methods: {
		loadData: function loadData() {
			var _this2 = this;

			this.running = true;
			this.$http.get('transmitters').then(function (response) {

				response.body.forEach(function (transmitter) {
					if (_this2.$store.getters.user.admin && transmitter.address !== null) {
						transmitter.address = transmitter.address.ip_addr + ':' + transmitter.address.port;
					} else {
						transmitter.address = '---';
					}

					if (transmitter.deviceType === null) transmitter.deviceType = '---';
					if (transmitter.usage === 'WIDERANGE') {
						transmitter.deviceType = '<img src="./assets/img/transmitter_widerange.png" title="Widerange"> ' + transmitter.deviceType;
					} else if (transmitter.usage === 'PERSONAL') {
						transmitter.deviceType = '<img src="./assets/img/transmitter_personal.png" title="Personal"> ' + transmitter.deviceType;
					}

					if (transmitter.status === 'ONLINE') {
						transmitter.status = '<span class="label label-success">ONLINE</span>';
					} else if (transmitter.status === 'OFFLINE') {
						transmitter.status = '<span class="label label-primary">OFFLINE</span>';
					} else {
						transmitter.status = '<span class="label label-warning">' + transmitter.status + '</span>';
					}

					transmitter.actions = false;
					if (_this2.$store.getters.user.admin || transmitter.ownerNames.includes(_this2.$store.getters.user.name)) {
						transmitter.actions = true;
					}
				});

				_this2.table.rows = response.body;

				_this2.running = false;
				_this2.errorMessage = false;
			}, function (response) {
				_this2.running = false;
				_this2.errorMessage = _this2.$helpers.getAjaxErrorMessage(response);
			});
		},
		mailToOwner: function mailToOwner(element) {
			var _this3 = this;

			var mailTo = [];
			this.$http.get('users').then(function (response) {
				response.body.forEach(function (user) {
					if (element.ownerNames.includes(user.name)) {
						mailTo.push(user.mail);
					}
				});
				window.location.href = 'mailto:' + mailTo.join(',') + '?subject=DAPNET%20Transmitter%3A%20' + element.name;
			}, function (response) {
				_this3.$dialogs.ajaxError(_this3, response);
			});
		},
		editElement: function editElement(element) {
			this.$router.push({ name: 'Edit Transmitter', params: { id: element.name } });
		},
		deleteElement: function deleteElement(element) {
			var _this4 = this;

			this.$dialogs.deleteElement(this, function () {
				_this4.$http.delete('transmitters/' + element.name, {
					before: function before(request) {
						request.headers.delete('Content-Type');
					}
				}).then(function (response) {
					_this4.loadData();
				}, function (response) {
					_this4.$dialogs.ajaxError(_this4, response);
				});
			});
		},
		mailToAll: function mailToAll() {
			var _this5 = this;

			var mailTo = [];
			this.$http.get('users').then(function (response) {
				response.body.forEach(function (user) {
					_this5.table.rows.forEach(function (row) {
						if (row.ownerNames.includes(user.name) && !mailTo.includes(user.mail)) {
							mailTo.push(user.mail);
						}
					});
				});
				window.location.href = 'mailto:' + mailTo.join(',') + '?subject=DAPNET%20Transmitter';
			}, function (response) {
				_this5.$dialogs.ajaxError(_this5, response);
			});
		}
	}
});

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	created: function created() {
		var _this = this;

		this.$http.get('transmitters').then(function (response) {
			response.body.forEach(function (transmitter) {
				_this.formData.transmitters.push({ name: transmitter.name });
			});
		});

		this.$http.get('users').then(function (response) {
			response.body.forEach(function (user) {
				_this.formData.users.push({ name: user.name });
			});
		});

		if (this.$route.params.id) {
			this.$http.get('transmitterGroups/' + this.$route.params.id).then(function (response) {
				_this.editing = true;

				var transmitterNames = [];
				response.body.transmitterNames.forEach(function (transmitter) {
					transmitterNames.push({ name: transmitter });
				});

				var ownerNames = [];
				response.body.ownerNames.forEach(function (owner) {
					ownerNames.push({ name: owner });
				});

				_this.form.name = response.body.name;
				_this.form.description = response.body.description;
				_this.form.transmitters = transmitterNames;
				_this.form.owners = ownerNames;
			}, function (response) {
				_this.$router.push('/transmitters/groups');
			});
		}
	},
	data: function data() {
		return {
			editing: false,
			form: {
				name: '',
				description: '',
				transmitters: [],
				owners: []
			},
			formData: {
				transmitters: [],
				users: []
			}
		};
	},

	methods: {
		submitForm: function submitForm(event) {
			var _this2 = this;

			event.preventDefault();

			if (!this.$helpers.checkForInput(this, this.form)) {
				return false;
			}

			var transmitterNames = [];
			this.form.transmitters.forEach(function (transmitter) {
				transmitterNames.push(transmitter.name);
			});

			var ownerNames = [];
			this.form.owners.forEach(function (owner) {
				ownerNames.push(owner.name);
			});

			var body = {
				description: this.form.description,
				transmitterNames: transmitterNames,
				ownerNames: ownerNames
			};

			this.$http.put('transmitterGroups/' + this.form.name, body).then(function (response) {
				_this2.$router.push('/transmitters/groups');
			}, function (response) {
				_this2.$dialogs.ajaxError(_this2, response);
			});
		}
	}
});

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	created: function created() {
		this.loadData();
	},
	data: function data() {
		return {
			errorMessage: false,
			running: false,
			table: {
				columns: [{
					id: 'name',
					title: 'Name'
				}, {
					id: 'description',
					title: 'Description'
				}, {
					id: 'transmitterNames',
					title: 'Transmitters'
				}, {
					id: 'ownerNames',
					title: 'Owner'
				}, {
					id: 'actions',
					title: 'Actions'
				}],
				rows: false
			}
		};
	},

	computed: {
		statTotal: function statTotal() {
			return this.table.rows.length;
		}
	},
	methods: {
		loadData: function loadData() {
			var _this = this;

			this.running = true;
			this.$http.get('transmitterGroups').then(function (response) {

				response.body.forEach(function (transmittergroup) {
					transmittergroup.actions = false;
					if (_this.$store.getters.user.admin || transmittergroup.ownerNames.includes(_this.$store.getters.user.name)) {
						transmittergroup.actions = true;
					}
				});

				_this.table.rows = response.body;

				_this.running = false;
				_this.errorMessage = false;
			}, function (response) {
				_this.running = false;
				_this.errorMessage = _this.$helpers.getAjaxErrorMessage(response);
			});
		},
		editElement: function editElement(element) {
			this.$router.push({ name: 'Edit Transmitter Group', params: { id: element.name } });
		},
		deleteElement: function deleteElement(element) {
			var _this2 = this;

			this.$dialogs.deleteElement(this, function () {
				_this2.$http.delete('transmitterGroups/' + element.name, {
					before: function before(request) {
						request.headers.delete('Content-Type');
					}
				}).then(function (response) {
					_this2.loadData();
				}, function (response) {
					_this2.$dialogs.ajaxError(_this2, response);
				});
			});
		}
	}
});

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	created: function created() {
		var _this = this;

		if (this.$route.params.id) {
			this.$http.get('users/' + this.$route.params.id).then(function (response) {
				_this.editing = true;

				_this.form.name = response.body.name;
				_this.form.email = response.body.mail;
				_this.form.admin = response.body.admin;
			}, function (response) {
				_this.$router.push('/users');
			});
		}
	},
	data: function data() {
		return {
			editing: false,
			form: {
				name: '',
				password: '',
				email: '',
				admin: false
			},
			passwordGenerated: ''
		};
	},

	methods: {
		submitForm: function submitForm(event) {
			var _this2 = this;

			event.preventDefault();

			if (this.$route.params.id && this.form.password === '') {
				this.form.password = '~~~DO_NOT_CHANGE_PASSWORD~~~';
			}

			if (!this.$helpers.checkForInput(this, this.form)) {
				return false;
			}

			if (this.$route.params.id && this.form.password === '~~~DO_NOT_CHANGE_PASSWORD~~~') {
				this.form.password = '';
			}

			var body = {
				hash: this.form.password,
				mail: this.form.email,
				admin: this.form.admin
			};

			this.$http.put('users/' + this.form.name, body).then(function (response) {
				if (_this2.form.name === _this2.$store.getters.user.name) {
					_this2.$store.commit('login', {
						name: _this2.form.name,
						auth: btoa(_this2.form.name + ':' + _this2.form.password),
						admin: _this2.form.admin
					});
				}

				_this2.$router.push('/users');
			}, function (response) {
				_this2.$dialogs.ajaxError(_this2, response);
			});
		},
		generatePassword: function generatePassword() {
			var chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
			var password = '';
			for (var i = 0; i < 20; ++i) {
				password += chars.charAt(Math.floor(Math.random() * chars.length));
			}

			this.form.password = password;
			this.passwordGenerated = password;
		}
	}
});

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	created: function created() {
		this.loadData();
	},
	data: function data() {
		return {
			errorMessage: false,
			running: false,
			table: {
				columns: [{
					id: 'name',
					title: 'Name'
				}, {
					id: 'mail',
					title: 'Email'
				}, {
					id: 'admin',
					title: 'Admin?'
				}, {
					id: 'callsigns',
					title: 'Callsigns'
				}, {
					id: 'actions',
					title: 'Actions'
				}],
				rows: false
			}
		};
	},

	computed: {
		statAdministrators: function statAdministrators() {
			return this.table.rows.filter(function (value) {
				return value.admin;
			}).length;
		},
		statTotal: function statTotal() {
			return this.table.rows.length;
		}
	},
	methods: {
		loadData: function loadData() {
			var _this = this;

			this.running = true;
			this.$http.get('users').then(function (response) {
				response.body.forEach(function (user) {
					user.actions = false;
					if (_this.$store.getters.user.admin || user.name === _this.$store.getters.user.name) {
						user.actions = true;
					}
				});

				_this.matchCallsigns(response.body);
			}, function (response) {
				_this.running = false;
				_this.errorMessage = _this.$helpers.getAjaxErrorMessage(response);
			});
		},
		matchCallsigns: function matchCallsigns(data) {
			var _this2 = this;

			this.running = true;
			this.$http.get('callsigns').then(function (response) {
				data.forEach(function (user) {
					user.callsigns = [];
					response.body.forEach(function (callsign) {
						if (callsign.ownerNames.includes(user.name)) {
							user.callsigns.push(callsign.name);
						}
					});
				});

				_this2.table.rows = data;

				_this2.running = false;
				_this2.errorMessage = false;
			}, function (response) {
				_this2.running = false;
				_this2.table.rows = data;
			});
		},
		mailToOwner: function mailToOwner(element) {
			window.location.href = 'mailto:' + element.mail + '?subject=DAPNET%20User%3A%20' + element.name;
		},
		editElement: function editElement(element) {
			this.$router.push({ name: 'Edit User', params: { id: element.name } });
		},
		deleteElement: function deleteElement(element) {
			var _this3 = this;

			this.$dialogs.deleteElement(this, function () {
				_this3.$http.delete('users/' + element.name, {
					before: function before(request) {
						request.headers.delete('Content-Type');
					}
				}).then(function (response) {
					_this3.loadData();
				}, function (response) {
					_this3.$dialogs.ajaxError(_this3, response);
				});
			});
		},
		mailToAll: function mailToAll() {
			var mailTo = [];
			this.table.rows.forEach(function (user) {
				if (!mailTo.includes(user.mail)) {
					mailTo.push(user.mail);
				}
			});
			window.location.href = 'mailto:' + mailTo.join(',') + '?subject=DAPNET%20User';
		}
	}
});

/***/ }),
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 401 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 402 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 403 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 404 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 405 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 406 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 407 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 408 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 409 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 410 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 411 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 412 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 413 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 414 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 415 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 416 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 417 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 418 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 419 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 420 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 421 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 422 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 423 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 424 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 425 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 426 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 427 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 428 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 429 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 430 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 431 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 131,
	"./af.js": 131,
	"./ar": 139,
	"./ar-dz": 132,
	"./ar-dz.js": 132,
	"./ar-kw": 133,
	"./ar-kw.js": 133,
	"./ar-ly": 134,
	"./ar-ly.js": 134,
	"./ar-ma": 135,
	"./ar-ma.js": 135,
	"./ar-ps": 136,
	"./ar-ps.js": 136,
	"./ar-sa": 137,
	"./ar-sa.js": 137,
	"./ar-tn": 138,
	"./ar-tn.js": 138,
	"./ar.js": 139,
	"./az": 140,
	"./az.js": 140,
	"./be": 141,
	"./be.js": 141,
	"./bg": 142,
	"./bg.js": 142,
	"./bm": 143,
	"./bm.js": 143,
	"./bn": 145,
	"./bn-bd": 144,
	"./bn-bd.js": 144,
	"./bn.js": 145,
	"./bo": 146,
	"./bo.js": 146,
	"./br": 147,
	"./br.js": 147,
	"./bs": 148,
	"./bs.js": 148,
	"./ca": 149,
	"./ca.js": 149,
	"./cs": 150,
	"./cs.js": 150,
	"./cv": 151,
	"./cv.js": 151,
	"./cy": 152,
	"./cy.js": 152,
	"./da": 153,
	"./da.js": 153,
	"./de": 156,
	"./de-at": 154,
	"./de-at.js": 154,
	"./de-ch": 155,
	"./de-ch.js": 155,
	"./de.js": 156,
	"./dv": 157,
	"./dv.js": 157,
	"./el": 158,
	"./el.js": 158,
	"./en-au": 159,
	"./en-au.js": 159,
	"./en-ca": 160,
	"./en-ca.js": 160,
	"./en-gb": 161,
	"./en-gb.js": 161,
	"./en-ie": 162,
	"./en-ie.js": 162,
	"./en-il": 163,
	"./en-il.js": 163,
	"./en-in": 164,
	"./en-in.js": 164,
	"./en-nz": 165,
	"./en-nz.js": 165,
	"./en-sg": 166,
	"./en-sg.js": 166,
	"./eo": 167,
	"./eo.js": 167,
	"./es": 171,
	"./es-do": 168,
	"./es-do.js": 168,
	"./es-mx": 169,
	"./es-mx.js": 169,
	"./es-us": 170,
	"./es-us.js": 170,
	"./es.js": 171,
	"./et": 172,
	"./et.js": 172,
	"./eu": 173,
	"./eu.js": 173,
	"./fa": 174,
	"./fa.js": 174,
	"./fi": 175,
	"./fi.js": 175,
	"./fil": 176,
	"./fil.js": 176,
	"./fo": 177,
	"./fo.js": 177,
	"./fr": 180,
	"./fr-ca": 178,
	"./fr-ca.js": 178,
	"./fr-ch": 179,
	"./fr-ch.js": 179,
	"./fr.js": 180,
	"./fy": 181,
	"./fy.js": 181,
	"./ga": 182,
	"./ga.js": 182,
	"./gd": 183,
	"./gd.js": 183,
	"./gl": 184,
	"./gl.js": 184,
	"./gom-deva": 185,
	"./gom-deva.js": 185,
	"./gom-latn": 186,
	"./gom-latn.js": 186,
	"./gu": 187,
	"./gu.js": 187,
	"./he": 188,
	"./he.js": 188,
	"./hi": 189,
	"./hi.js": 189,
	"./hr": 190,
	"./hr.js": 190,
	"./hu": 191,
	"./hu.js": 191,
	"./hy-am": 192,
	"./hy-am.js": 192,
	"./id": 193,
	"./id.js": 193,
	"./is": 194,
	"./is.js": 194,
	"./it": 196,
	"./it-ch": 195,
	"./it-ch.js": 195,
	"./it.js": 196,
	"./ja": 197,
	"./ja.js": 197,
	"./jv": 198,
	"./jv.js": 198,
	"./ka": 199,
	"./ka.js": 199,
	"./kk": 200,
	"./kk.js": 200,
	"./km": 201,
	"./km.js": 201,
	"./kn": 202,
	"./kn.js": 202,
	"./ko": 203,
	"./ko.js": 203,
	"./ku": 205,
	"./ku-kmr": 204,
	"./ku-kmr.js": 204,
	"./ku.js": 205,
	"./ky": 206,
	"./ky.js": 206,
	"./lb": 207,
	"./lb.js": 207,
	"./lo": 208,
	"./lo.js": 208,
	"./lt": 209,
	"./lt.js": 209,
	"./lv": 210,
	"./lv.js": 210,
	"./me": 211,
	"./me.js": 211,
	"./mi": 212,
	"./mi.js": 212,
	"./mk": 213,
	"./mk.js": 213,
	"./ml": 214,
	"./ml.js": 214,
	"./mn": 215,
	"./mn.js": 215,
	"./mr": 216,
	"./mr.js": 216,
	"./ms": 218,
	"./ms-my": 217,
	"./ms-my.js": 217,
	"./ms.js": 218,
	"./mt": 219,
	"./mt.js": 219,
	"./my": 220,
	"./my.js": 220,
	"./nb": 221,
	"./nb.js": 221,
	"./ne": 222,
	"./ne.js": 222,
	"./nl": 224,
	"./nl-be": 223,
	"./nl-be.js": 223,
	"./nl.js": 224,
	"./nn": 225,
	"./nn.js": 225,
	"./oc-lnc": 226,
	"./oc-lnc.js": 226,
	"./pa-in": 227,
	"./pa-in.js": 227,
	"./pl": 228,
	"./pl.js": 228,
	"./pt": 230,
	"./pt-br": 229,
	"./pt-br.js": 229,
	"./pt.js": 230,
	"./ro": 231,
	"./ro.js": 231,
	"./ru": 232,
	"./ru.js": 232,
	"./sd": 233,
	"./sd.js": 233,
	"./se": 234,
	"./se.js": 234,
	"./si": 235,
	"./si.js": 235,
	"./sk": 236,
	"./sk.js": 236,
	"./sl": 237,
	"./sl.js": 237,
	"./sq": 238,
	"./sq.js": 238,
	"./sr": 240,
	"./sr-cyrl": 239,
	"./sr-cyrl.js": 239,
	"./sr.js": 240,
	"./ss": 241,
	"./ss.js": 241,
	"./sv": 242,
	"./sv.js": 242,
	"./sw": 243,
	"./sw.js": 243,
	"./ta": 244,
	"./ta.js": 244,
	"./te": 245,
	"./te.js": 245,
	"./tet": 246,
	"./tet.js": 246,
	"./tg": 247,
	"./tg.js": 247,
	"./th": 248,
	"./th.js": 248,
	"./tk": 249,
	"./tk.js": 249,
	"./tl-ph": 250,
	"./tl-ph.js": 250,
	"./tlh": 251,
	"./tlh.js": 251,
	"./tr": 252,
	"./tr.js": 252,
	"./tzl": 253,
	"./tzl.js": 253,
	"./tzm": 255,
	"./tzm-latn": 254,
	"./tzm-latn.js": 254,
	"./tzm.js": 255,
	"./ug-cn": 256,
	"./ug-cn.js": 256,
	"./uk": 257,
	"./uk.js": 257,
	"./ur": 258,
	"./ur.js": 258,
	"./uz": 260,
	"./uz-latn": 259,
	"./uz-latn.js": 259,
	"./uz.js": 260,
	"./vi": 261,
	"./vi.js": 261,
	"./x-pseudo": 262,
	"./x-pseudo.js": 262,
	"./yo": 263,
	"./yo.js": 263,
	"./zh-cn": 264,
	"./zh-cn.js": 264,
	"./zh-hk": 265,
	"./zh-hk.js": 265,
	"./zh-mo": 266,
	"./zh-mo.js": 266,
	"./zh-tw": 267,
	"./zh-tw.js": 267
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 563;

/***/ }),
/* 564 */,
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/dapnet-logo.f6092f2.png";

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/pager.9890a2d.jpg";

/***/ }),
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */
/***/ (function(module, exports) {

module.exports = {"name":"vue-chartjs","version":"2.6.3","description":"vue.js wrapper for chart.js","author":"Jakub Juszczak <jakub@posteo.de>","homepage":"http://vue-chartjs.org","license":"MIT","contributors":[{"name":"Thorsten Lünborg","web":"https://github.com/LinusBorg"},{"name":"Juan Carlos Alonso","web":"https://github.com/jcalonso"}],"maintainers":[{"name":"Jakub Juszczak","email":"jakub@posteo.de","web":"http://www.jakubjuszczak.de"}],"repository":{"type":"git","url":"git+ssh://git@github.com:apertureless/vue-chartjs.git"},"bugs":{"url":"https://github.com/apertureless/vue-chartjs/issues"},"keywords":["ChartJs","Vue","Visualisation","Wrapper","Charts"],"main":"dist/vue-chartjs.js","unpkg":"dist/vue-chartjs.full.min.js","module":"es/index.js","jsnext:main":"es/index.js","files":["src","dist","es"],"scripts":{"dev":"node build/dev-server.js","build":"yarn run release && yarn run build:es","build:es":"cross-env BABEL_ENV=es babel src --out-dir es","unit":"karma start test/unit/karma.conf.js --single-run","e2e":"node test/e2e/runner.js","test":"npm run unit","lint":"eslint --ext .js,.vue src test/unit/specs test/e2e/specs","release":"webpack --progress --hide-modules --config  ./build/webpack.release.js && NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.min.js && webpack --progress --hide-modules --config  ./build/webpack.release.full.js && NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.full.min.js","prepublish":"yarn run lint && yarn run test && yarn run build"},"dependencies":{"lodash":"^4.17.4"},"peerDependencies":{"chart.js":"^2.5.0","vue":"^2.3.3"},"devDependencies":{"babel-cli":"^6.24.1","babel-core":"^6.24.1","babel-loader":"^7.0.0","babel-plugin-transform-runtime":"^6.23.0","babel-preset-es2015":"^6.24.1","babel-preset-stage-2":"^6.24.1","babel-runtime":"^6.23.0","chai":"^3.5.0","chart.js":"^2.5.0","chromedriver":"^2.28.0","connect-history-api-fallback":"^1.1.0","cross-env":"^3.2.4","cross-spawn":"^5.1.0","css-loader":"^0.28.0","eslint":"^3.19.0","eslint-config-standard":"^10.2.1","eslint-friendly-formatter":"^2.0.7","eslint-loader":"^1.7.1","eslint-plugin-html":"^2.0.1","eslint-plugin-import":"^2.2.0","eslint-plugin-node":"^4.2.2","eslint-plugin-promise":"^3.5.0","eslint-plugin-standard":"^3.0.1","eventsource-polyfill":"^0.9.6","express":"^4.15.2","extract-text-webpack-plugin":"^1.0.1","file-loader":"^0.10.1","function-bind":"^1.0.2","html-webpack-plugin":"^2.28.0","http-proxy-middleware":"^0.17.4","inject-loader":"^3.0.0","isparta-loader":"^2.0.0","jasmine-core":"^2.5.2","json-loader":"^0.5.4","karma":"^1.5.0","karma-coverage":"^1.1.1","karma-jasmine":"^1.0.2","karma-mocha":"^1.2.0","karma-phantomjs-launcher":"^1.0.4","karma-sinon-chai":"^1.2.0","karma-sourcemap-loader":"^0.3.7","karma-spec-reporter":"0.0.30","karma-webpack":"1.8.1","lolex":"^1.6.0","mocha":"^3.1.0","nightwatch":"^0.9.14","ora":"^1.2.0","phantomjs-prebuilt":"^2.1.13","selenium-server":"^3.3.1","shelljs":"^0.7.7","sinon":"^2.1.0","sinon-chai":"^2.9.0","url-loader":"^0.5.8","vue":"^2.3.3","vue-hot-reload-api":"^2.1.0","vue-html-loader":"^1.2.4","vue-loader":"^12.0.4","vue-style-loader":"^3.0.1","vue-template-compiler":"^2.3.3","webpack":"^1.13.2","webpack-dev-middleware":"^1.10.1","webpack-hot-middleware":"^2.17.1","webpack-merge":"1.1.1"},"engines":{"node":">=6.9.0"},"babel":{"presets":["es2015"]},"browserify":{"transform":["babelify"]},"greenkeeper":{"ignore":["extract-text-webpack-plugin","karma-webpack","webpack","webpack-merge"]}}

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(414)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(291),
  /* template */
  __webpack_require__(618),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-55f896b4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(429)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(292),
  /* template */
  __webpack_require__(633),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d64d9936",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(413)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(293),
  /* template */
  __webpack_require__(617),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-553f0f27",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(428)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(294),
  /* template */
  __webpack_require__(632),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c0984388",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(426)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(295),
  /* template */
  __webpack_require__(630),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-97b5ccf8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(412)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(296),
  /* template */
  __webpack_require__(616),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-51201dc5",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(402)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(297),
  /* template */
  __webpack_require__(606),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0745967e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(410)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(298),
  /* template */
  __webpack_require__(614),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-324efeb0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(300),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(408)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(301),
  /* template */
  __webpack_require__(612),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2d3e360e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(415)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(302),
  /* template */
  __webpack_require__(619),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-58323370",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(424)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(303),
  /* template */
  __webpack_require__(628),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7d1e6928",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(406)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(304),
  /* template */
  __webpack_require__(610),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-227af4a1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(417)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(305),
  /* template */
  __webpack_require__(621),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5bc61662",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(430)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(306),
  /* template */
  __webpack_require__(634),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ebe39b22",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(411)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(307),
  /* template */
  __webpack_require__(615),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4ce0ce38",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(407)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(313),
  /* template */
  __webpack_require__(611),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-23ff2173",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(420)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(314),
  /* template */
  __webpack_require__(624),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-68d371da",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(403)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(315),
  /* template */
  __webpack_require__(607),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-132fdcd4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(405)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(316),
  /* template */
  __webpack_require__(609),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1f0ce679",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(416)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(317),
  /* template */
  __webpack_require__(620),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5b2928bd",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(419)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(318),
  /* template */
  __webpack_require__(623),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6691aa2c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(423)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(319),
  /* template */
  __webpack_require__(627),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-78cf9d6d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(401)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(320),
  /* template */
  __webpack_require__(605),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-01aeb908",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(431)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(321),
  /* template */
  __webpack_require__(635),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-fb60641e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(427)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(322),
  /* template */
  __webpack_require__(631),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a0f3b510",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 605 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-9"
  }, [_c('h2', [_vm._v("All Transmitter Groups\n\t\t\t\t"), _c('i', {
    staticClass: "fa fa-refresh fa-fw",
    class: {
      'fa-spin': _vm.running
    },
    on: {
      "click": _vm.loadData
    }
  })]), _vm._v(" "), _c('info-error', {
    attrs: {
      "message": _vm.errorMessage
    }
  }), _vm._v(" "), (_vm.table.rows) ? _c('tablegrid', {
    attrs: {
      "columns": _vm.table.columns,
      "data": _vm.table.rows,
      "edit-action": _vm.editElement,
      "delete-action": _vm.deleteElement
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "actions well"
  }, [(this.$store.getters.user.admin) ? [_c('legend', [_vm._v("Actions")]), _vm._v(" "), _c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/transmitters/groups/new"
    }
  }, [_vm._v("New Transmitter Group")])], 1)]), _vm._v(" "), _c('br')] : _vm._e(), _vm._v(" "), (_vm.table.rows) ? [_c('legend', [_vm._v("Statistics")]), _vm._v(" "), _c('ul', {
    staticClass: "list-group"
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Total Groups")]), _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.statTotal))])])])] : _vm._e()], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v("Transmitter Groups")])])])])
}]}

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-9"
  }, [_c('form', {
    staticClass: "form-horizontal well"
  }, [_c('fieldset', [(!this.$route.params.id) ? _c('legend', [_vm._v("New Callsign")]) : _vm._e(), _vm._v(" "), (this.$route.params.id) ? _c('legend', [_vm._v("Edit Callsign")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Callsign")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.callsign),
      expression: "form.callsign"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.callsign)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.callsign = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v("Please enter a valid amateur radio callsign of a human or a classifying name of an organization.")]), _vm._v(" "), (_vm.editing) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("Changing this name will create a duplication and "), _c('i', [_vm._v("not")]), _vm._v(" change the element's name.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.description),
      expression: "form.description"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.description = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v("Provide your name or any other useful description of this entry.")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Pager")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.pager.numbers),
      expression: "form.pager.numbers"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "5"
    },
    domProps: {
      "value": (_vm.form.pager.numbers)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.pager.numbers = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.pager.names),
      expression: "form.pager.names"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "5"
    },
    domProps: {
      "value": (_vm.form.pager.names)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.pager.names = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v("Add a corresponding number for lines as a description for the RIC numbers given in the first box.")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Owner")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.formData.users,
      "multiple": true,
      "close-on-select": false,
      "hide-selected": true,
      "clear-on-select": true,
      "placeholder": "Type to search",
      "label": "name",
      "track-by": "name"
    },
    model: {
      value: (_vm.form.owners),
      callback: function($$v) {
        _vm.form.owners = $$v
      },
      expression: "form.owners"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v("An owner of a callsign association can edit the parameters of this callsign.")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-lg-10 col-lg-offset-2"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/callsigns"
    }
  }, [_c('button', {
    staticClass: "btn btn-default"
  }, [_vm._v("Abort")])])], 1)])])])]), _vm._v(" "), _vm._m(2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v("Callsigns")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "help-block"
  }, [_vm._v("Add one or more lines of pager RIC numbers. "), _c('img', {
    attrs: {
      "src": __webpack_require__(566),
      "alt": "Help"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-3"
  }, [_c('h2', [_vm._v("Information")]), _vm._v(" "), _c('p', [_vm._v("Callsigns are an allocation between a name (usually your amateur radio callsign) and one or multiple pager IDs.")])])
}]}

/***/ }),
/* 607 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-9"
  }, [_c('h2', [_vm._v("All Rubrics\n\t\t\t\t"), _c('i', {
    staticClass: "fa fa-refresh fa-fw",
    class: {
      'fa-spin': _vm.running
    },
    on: {
      "click": _vm.loadData
    }
  })]), _vm._v(" "), _c('info-error', {
    attrs: {
      "message": _vm.errorMessage
    }
  }), _vm._v(" "), (_vm.table.rows) ? _c('tablegrid', {
    attrs: {
      "columns": _vm.table.columns,
      "data": _vm.table.rows,
      "edit-action": _vm.editElement,
      "delete-action": _vm.deleteElement
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "actions well"
  }, [_c('legend', [_vm._v("Actions")]), _vm._v(" "), _c('ul', [(this.$store.getters.user.admin) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/rubrics/new"
    }
  }, [_vm._v("New Rubric")])], 1) : _vm._e(), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/rubrics/activate"
    }
  }, [_vm._v("Activate Rubrics")])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.table.rows) ? [_c('legend', [_vm._v("Statistics")]), _vm._v(" "), _c('ul', {
    staticClass: "list-group"
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Total Rubrics")]), _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.statTotal))])])])] : _vm._e()], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v("Rubrics")])])])])
}]}

/***/ }),
/* 608 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_vm._v("Search: "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "table-scrollable"
  }, [_c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', _vm._l((_vm.columns), function(key) {
    return _c('th', {
      class: {
        active: _vm.sortKey == key.id
      },
      on: {
        "click": function($event) {
          _vm.sortBy(key.id)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(key.title) + " "), _c('span', {
      staticClass: "arrow",
      class: _vm.sortOrders[key.id] > 0 ? 'asc' : 'dsc'
    })])
  }))]), _vm._v(" "), _c('tbody', _vm._l((_vm.paginatedData), function(entry) {
    return _c('tr', _vm._l((_vm.columns), function(key) {
      return _c('td', [(key.id === 'actions') ? [(entry[key.id] === true) ? [_c('action-buttons', {
        attrs: {
          "element": entry,
          "mail-action": _vm.mailAction,
          "edit-action": _vm.editAction,
          "delete-action": _vm.deleteAction
        }
      })] : [_vm._v("\n\t\t\t\t\t\t\t\t---\n\t\t\t\t\t\t\t")]] : (key.id === 'status' || key.id === 'deviceType') ? [_c('span', {
        domProps: {
          "innerHTML": _vm._s(entry[key.id])
        }
      })] : [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm._f("booleanToString")(_vm._f("arrayToString")(entry[key.id]))) + "\n\t\t\t\t\t\t")]], 2)
    }))
  }))])]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-default btn-xs",
    on: {
      "click": function($event) {
        _vm.movePages(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  })]), _vm._v("\n\t\t Page "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.gotoPage),
      expression: "gotoPage",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "number",
      "min": "1",
      "max": _vm.totalPages
    },
    domProps: {
      "value": (_vm.gotoPage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.gotoPage = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" of " + _vm._s(_vm.totalPages) + " \n\t\t"), _c('button', {
    staticClass: "btn btn-default btn-xs",
    on: {
      "click": function($event) {
        _vm.movePages(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-right"
  })])])])
},staticRenderFns: []}

/***/ }),
/* 609 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('v-map', {
    staticStyle: {
      "height": "40em"
    },
    attrs: {
      "zoom": _vm.zoom,
      "center": _vm.center
    }
  }, [_c('v-tilelayer', {
    attrs: {
      "url": _vm.url,
      "attribution": _vm.attribution
    }
  }), _vm._v(" "), _vm._l((_vm.markers), function(item) {
    return _c('v-marker', {
      key: item.name,
      attrs: {
        "lat-lng": item.position,
        "icon": item.icon
      }
    }, [_c('v-popup', {
      attrs: {
        "content": item.popup
      }
    })], 1)
  }), _vm._v(" "), _vm._l((_vm.lines), function(item) {
    return _c('v-polyline', {
      key: item.name,
      attrs: {
        "lat-lngs": item.position,
        "color": item.color
      }
    })
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('h2', [_vm._v("Settings")]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.widerangeOnly),
      expression: "settings.widerangeOnly"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.settings.widerangeOnly) ? _vm._i(_vm.settings.widerangeOnly, null) > -1 : (_vm.settings.widerangeOnly)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.settings.widerangeOnly,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.settings.widerangeOnly = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.settings.widerangeOnly = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.settings.widerangeOnly = $$c
        }
      }
    }
  }), _vm._v(" Show Widerange-transmitter only")]), _c('br'), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.showNodes),
      expression: "settings.showNodes"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.settings.showNodes) ? _vm._i(_vm.settings.showNodes, null) > -1 : (_vm.settings.showNodes)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.settings.showNodes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.settings.showNodes = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.settings.showNodes = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.settings.showNodes = $$c
        }
      }
    }
  }), _vm._v(" Show nodes")]), _c('br'), _vm._v(" "), (_vm.settings.showNodes) ? _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.showLines),
      expression: "settings.showLines"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.settings.showLines) ? _vm._i(_vm.settings.showLines, null) > -1 : (_vm.settings.showLines)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.settings.showLines,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.settings.showLines = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.settings.showLines = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.settings.showLines = $$c
        }
      }
    }
  }), _vm._v(" Show line from transmitter to node")]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v("Map")])])])])
}]}

/***/ }),
/* 610 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-9"
  }, [_c('h2', [_vm._v("All Nodes\n\t\t\t\t"), _c('i', {
    staticClass: "fa fa-refresh fa-fw",
    class: {
      'fa-spin': _vm.running
    },
    on: {
      "click": _vm.loadData
    }
  })]), _vm._v(" "), _c('info-error', {
    attrs: {
      "message": _vm.errorMessage
    }
  }), _vm._v(" "), (_vm.table.rows) ? _c('tablegrid', {
    attrs: {
      "columns": _vm.table.columns,
      "data": _vm.table.rows,
      "mail-action": _vm.mailToOwner,
      "edit-action": _vm.editElement,
      "delete-action": _vm.deleteElement
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "actions well"
  }, [(this.$store.getters.user.admin) ? [_c('legend', [_vm._v("Actions")]), _vm._v(" "), _c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/nodes/new"
    }
  }, [_vm._v("New Node")])], 1), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "linklike",
    on: {
      "click": _vm.mailToAll
    }
  }, [_vm._v("Send a mail to all owners")])])]), _vm._v(" "), _c('br')] : _vm._e(), _vm._v(" "), (_vm.table.rows) ? [_c('legend', [_vm._v("Statistics")]), _vm._v(" "), _c('ul', {
    staticClass: "list-group"
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Total Nodes")]), _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.statTotal))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('chart-online-offline', {
    attrs: {
      "chartData": _vm.chartData
    }
  })], 1)])] : _vm._e()], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v("Nodes")])])])])
}]}

/***/ }),
/* 611 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-9"
  }, [_c('form', {
    staticClass: "form-horizontal well"
  }, [_c('fieldset', [_c('legend', [_vm._v("Activate Rubric")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Pager-number")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.form.number),
      expression: "form.number",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "max": "2097151",
      "placeholder": "0 - 2097151"
    },
    domProps: {
      "value": (_vm.form.number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.number = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Transmitter Groups")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.formData.transmittergroups,
      "multiple": true,
      "close-on-select": false,
      "hide-selected": true,
      "clear-on-select": true,
      "placeholder": "Type to search",
      "label": "name",
      "track-by": "name"
    },
    model: {
      value: (_vm.form.transmittergroups),
      callback: function($$v) {
        _vm.form.transmittergroups = $$v
      },
      expression: "form.transmittergroups"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-lg-10 col-lg-offset-2"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/rubrics"
    }
  }, [_c('button', {
    staticClass: "btn btn-default"
  }, [_vm._v("Abort")])])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v("Rubrics")])])])])
}]}

/***/ }),
/* 612 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-9"
  }, [_c('form', {
    staticClass: "form-horizontal well"
  }, [_c('fieldset', [_c('legend', [_vm._v("New News")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Message")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.message),
      expression: "form.message"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "2",
      "maxlength": "80"
    },
    domProps: {
      "value": (_vm.form.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.message = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.messageCharsRemaining) + " / 80 characters remaining.")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Rubric")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.formData.rubrics,
      "close-on-select": true,
      "hide-selected": true,
      "clear-on-select": true,
      "placeholder": "Type to search",
      "label": "name",
      "track-by": "name"
    },
    model: {
      value: (_vm.form.rubric),
      callback: function($$v) {
        _vm.form.rubric = $$v
      },
      expression: "form.rubric"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Number")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5 checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.numberNext),
      expression: "form.numberNext"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.numberNext) ? _vm._i(_vm.form.numberNext, null) > -1 : (_vm.form.numberNext)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.form.numberNext,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.form.numberNext = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.form.numberNext = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.numberNext = $$c
        }
      }
    }
  }), _vm._v(" Choose automatically")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.form.number),
      expression: "form.number",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "disabled": _vm.form.numberNext == 1,
      "min": "1",
      "max": "10",
      "placeholder": "1 - 10"
    },
    domProps: {
      "value": (_vm.form.number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.number = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-lg-10 col-lg-offset-2"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/news"
    }
  }, [_c('button', {
    staticClass: "btn btn-default"
  }, [_vm._v("Abort")])])], 1)])])])]), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v("News")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-3"
  }, [_c('h2', [_vm._v("Information")]), _vm._v(" "), _c('p', [_vm._v("News are the contents of rubrics. They are up to now only available on Skyper paging receivers.")])])
}]}

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar navbar-default navbar-fixed-top"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('router-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(565),
      "alt": "DAPNET Logo"
    }
  })]), _vm._v(" "), _vm._m(0)], 1), _vm._v(" "), _c('div', {
    staticClass: "navbar-collapse collapse",
    attrs: {
      "id": "navbar-main"
    }
  }, [(this.$store.getters.isUserLoggedIn) ? _c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', {
    staticClass: "divider-vertical"
  }), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/calls"
    }
  }, [_vm._v("Calls")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/callsigns"
    }
  }, [_vm._v("Callsigns")])], 1), _vm._v(" "), _c('li', {
    staticClass: "divider-vertical"
  }), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/news"
    }
  }, [_vm._v("News")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/rubrics"
    }
  }, [_vm._v("Rubrics")])], 1), _vm._v(" "), _c('li', {
    staticClass: "divider-vertical"
  }), _vm._v(" "), _c('li', {
    staticClass: "dropdown"
  }, [_vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    attrs: {
      "role": "menu"
    }
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/transmitters"
    }
  }, [_vm._v("All Transmitters")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/transmitters/map"
    }
  }, [_vm._v("Map")])], 1), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/transmitters/groups"
    }
  }, [_vm._v("Transmitter Groups")])], 1)])]), _vm._v(" "), _c('li', {
    staticClass: "divider-vertical"
  }), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/nodes"
    }
  }, [_vm._v("Nodes")])], 1), _vm._v(" "), _c('li', {
    staticClass: "divider-vertical"
  }), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/users"
    }
  }, [_vm._v("Users")])], 1), _vm._v(" "), _c('li', {
    staticClass: "divider-vertical"
  })]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-expanded": "false"
    }
  }, [_vm._v(_vm._s(this.$store.getters.user.name) + " "), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    attrs: {
      "role": "menu"
    }
  }, [(this.$store.getters.isUserLoggedIn) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Edit User',
        params: {
          id: this.$store.getters.user.name
        }
      }
    }
  }, [_vm._v("Settings")])], 1) : _vm._e(), _vm._v(" "), (this.$store.getters.isUserLoggedIn) ? _c('div', {
    staticClass: "divider"
  }) : _vm._e(), _vm._v(" "), (!this.$store.getters.isUserLoggedIn) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Login")])], 1) : _vm._e(), _vm._v(" "), (this.$store.getters.isUserLoggedIn) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/logout"
    }
  }, [_vm._v("Logout")])], 1) : _vm._e()])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#navbar-main"
    }
  }, [_c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-expanded": "false"
    }
  }, [_vm._v("Transmitters "), _c('span', {
    staticClass: "caret"
  })])
}]}

/***/ }),
/* 614 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-9"
  }, [_c('h2', [_vm._v("All Callsigns\n\t\t\t\t"), _c('i', {
    staticClass: "fa fa-refresh fa-fw",
    class: {
      'fa-spin': _vm.running
    },
    on: {
      "click": _vm.loadData
    }
  })]), _vm._v(" "), _c('info-error', {
    attrs: {
      "message": _vm.errorMessage
    }
  }), _vm._v(" "), (_vm.table.rows) ? _c('tablegrid', {
    attrs: {
      "columns": _vm.table.columns,
      "data": _vm.table.rows,
      "edit-action": _vm.editElement,
      "delete-action": _vm.deleteElement
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "actions well"
  }, [(this.$store.getters.user.admin) ? [_c('legend', [_vm._v("Actions")]), _vm._v(" "), _c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/callsigns/new"
    }
  }, [_vm._v("New Callsign")])], 1)]), _vm._v(" "), _c('br')] : _vm._e(), _vm._v(" "), (_vm.table.rows) ? [_c('legend', [_vm._v("Statistics")]), _vm._v(" "), _c('ul', {
    staticClass: "list-group"
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Total Callsigns")]), _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.statTotal))])])])] : _vm._e()], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v("Callsigns")])])])])
}]}

/***/ }),
/* 615 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v("Privacy")])]), _vm._v(" "), _c('h2', [_vm._v("Datenschutz")]), _vm._v(" "), _c('p', [_vm._v("Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.")]), _vm._v(" "), _c('p', [_vm._v("Die Nutzung unserer Webseite ist in der Regel ohne Angabe personenbezogener Daten möglich. Soweit auf unseren Seiten personenbezogene Daten (beispielsweise Name, Anschrift oder E-Mail-Adressen) erhoben werden, erfolgt dies, soweit möglich, stets auf freiwilliger Basis. Diese Daten werden ohne Ihre ausdrückliche Zustimmung nicht an Dritte weitergegeben.")]), _vm._v(" "), _c('p', [_vm._v("Wir weisen darauf hin, dass die Datenübertragung im Internet (z.B. bei der Kommunikation per E-Mail) Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht möglich.")])])])])
}]}

/***/ }),
/* 616 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-9"
  }, [_c('h2', [_vm._v("All Calls\n\t\t\t\t"), _c('i', {
    staticClass: "fa fa-refresh fa-fw",
    class: {
      'fa-spin': _vm.running
    },
    on: {
      "click": _vm.loadData
    }
  })]), _vm._v(" "), _c('info-error', {
    attrs: {
      "message": _vm.errorMessage
    }
  }), _vm._v(" "), (_vm.table.rows) ? _c('tablegrid', {
    attrs: {
      "columns": _vm.table.columns,
      "data": _vm.table.rows
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "actions well"
  }, [_c('legend', [_vm._v("Actions")]), _vm._v(" "), _c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/calls/new"
    }
  }, [_vm._v("New Call")])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.table.rows) ? [_c('legend', [_vm._v("Statistics")]), _vm._v(" "), _c('ul', {
    staticClass: "list-group"
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Emergencies")]), _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.statEmergencies))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Total Calls")]), _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.statTotal))])])])] : _vm._e()], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v("Calls")])])])])
}]}

/***/ }),
/* 617 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-8"
  }, [_c('form', {
    staticClass: "form-horizontal well"
  }, [_c('fieldset', [_c('legend', [_vm._v("Login")]), _vm._v(" "), _c('info-error', {
    attrs: {
      "message": _vm.errorMessage
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Username")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Username"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Password")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-lg-10 col-lg-offset-2"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("Submit")])])])], 1)])]), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v("Login")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-4"
  }, [_c('h2', [_vm._v("Information")]), _vm._v(" "), _c('p', [_vm._v("...")])])
}]}

/***/ }),
/* 618 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "jumbotron"
  }, [_c('h1', [_vm._v("Welcome!")]), _vm._v(" "), (!this.$store.getters.isUserLoggedIn) ? _c('p', [_vm._v("In order to use this service, please "), _c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("login")]), _vm._v(" first.")], 1) : _vm._e(), _vm._v(" "), (this.$store.getters.isUserLoggedIn) ? _c('p', [_vm._v("You are logged in, " + _vm._s(this.$store.getters.user.name) + ".")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('h2', [_vm._v("Information")]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(this.$store.getters.customText)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('h2', [_vm._v("Statistics\n\t\t\t\t"), _c('i', {
    staticClass: "fa fa-refresh fa-fw",
    class: {
      'fa-spin': _vm.stats.running
    },
    on: {
      "click": _vm.loadData
    }
  })]), _vm._v(" "), _c('info-error', {
    attrs: {
      "message": _vm.stats.errorMessage
    }
  }), _vm._v(" "), (_vm.stats.data) ? _c('ul', {
    staticClass: "list-group"
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Calls")]), _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.stats.data.calls))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Callsigns")]), _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.stats.data.callSigns))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("News")]), _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.stats.data.news))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Rubrics")]), _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.stats.data.rubrics))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Transmitters")]), _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.statTransmitter))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Nodes")]), _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.statNodes))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Users")]), _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.stats.data.users))])])]) : _vm._e()], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-4"
  }, [_c('h2', [_vm._v("Digital Pager Network freeband.digital")]), _vm._v(" "), _c('div', {
    staticClass: "well"
  }, [_c('h3', [_vm._v("Projects")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "https://freeband.digital",
      "target": "_blank"
    }
  }, [_vm._v("freeband.digital")])])])])])
}]}

/***/ }),
/* 619 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-9"
  }, [_c('h2', [_vm._v("All News\n\t\t\t\t"), _c('i', {
    staticClass: "fa fa-refresh fa-fw",
    class: {
      'fa-spin': _vm.running
    },
    on: {
      "click": _vm.loadData
    }
  })]), _vm._v(" "), _c('info-error', {
    attrs: {
      "message": _vm.errorMessage
    }
  }), _vm._v(" "), (_vm.table.rows) ? _c('tablegrid', {
    attrs: {
      "columns": _vm.table.columns,
      "data": _vm.table.rows
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "actions well"
  }, [_c('legend', [_vm._v("Actions")]), _vm._v(" "), _c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/news/new"
    }
  }, [_vm._v("New News")])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.table.rows) ? [_c('legend', [_vm._v("Statistics")]), _vm._v(" "), _c('ul', {
    staticClass: "list-group"
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Total Calls")]), _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.statTotal))])])])] : _vm._e()], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v("News")])])])])
}]}

/***/ }),
/* 620 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-9"
  }, [_c('form', {
    staticClass: "form-horizontal well"
  }, [_c('fieldset', [(!this.$route.params.id) ? _c('legend', [_vm._v("New Transmitter")]) : _vm._e(), _vm._v(" "), (this.$route.params.id) ? _c('legend', [_vm._v("Edit Transmitter")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Callsign")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.name),
      expression: "form.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v("Enter a valid amateur radio callsign of this transmitter. It will be also used for the 10 minute interval transmitter identification message to fulfill the law (at least the German law).")]), _vm._v(" "), (_vm.editing) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("Changing this name will create a duplication and "), _c('i', [_vm._v("not")]), _vm._v(" change the element's name.")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.formData.hamnetDb.all,
      "multiple": false,
      "close-on-select": true,
      "hide-selected": true,
      "clear-on-select": true,
      "placeholder": "Type to search",
      "label": "name",
      "track-by": "name"
    },
    model: {
      value: (_vm.formData.hamnetDb.selected),
      callback: function($$v) {
        _vm.formData.hamnetDb.selected = $$v
      },
      expression: "formData.hamnetDb.selected"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v("Easy import of stations from hamnetdb.net. Location data of the selected transmitter site will be copied into the form.")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Node")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.formData.nodes,
      "close-on-select": true,
      "hide-selected": true,
      "clear-on-select": true,
      "placeholder": "Type to search",
      "label": "name",
      "track-by": "name"
    },
    model: {
      value: (_vm.form.node),
      callback: function($$v) {
        _vm.form.node = $$v
      },
      expression: "form.node"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v("Select the DAPNET-Node which shall receive the transmitter TCP connection. Just this DAPNET-Node will accept a connection from this specific transmitter.")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Password")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.password),
      expression: "form.password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v("Enter a authentication password for this transmitter. In the UniPager webinterface it’s called Auth Key.")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Latitude / Longitude")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.form.latitude.value),
      expression: "form.latitude.value",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "max": "90",
      "placeholder": "0 - 90"
    },
    domProps: {
      "value": (_vm.form.latitude.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.latitude.value = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.form.latitude.orientation),
      expression: "form.latitude.orientation",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.form.latitude.orientation = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("North")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "-1"
    }
  }, [_vm._v("South")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.form.longitude.value),
      expression: "form.longitude.value",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "max": "180",
      "placeholder": "0 - 180"
    },
    domProps: {
      "value": (_vm.form.longitude.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.longitude.value = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.form.longitude.orientation),
      expression: "form.longitude.orientation",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.form.longitude.orientation = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("East")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "-1"
    }
  }, [_vm._v("West")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Usage")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.usage),
      expression: "form.usage"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.form.usage = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "PERSONAL"
    }
  }, [_vm._v("Personal")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "WIDERANGE"
    }
  }, [_vm._v("Widerange")])]), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v("For classification of the transmitters, there are two categories: Personal (Transmitters with low output power like RasPager) and Wide Range (Higher output power and elevated location site).")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Antenna Type")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.antennatype),
      expression: "form.antennatype"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.form.antennatype = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "OMNI"
    }
  }, [_vm._v("Omni")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DIRECTIONAL"
    }
  }, [_vm._v("Directional")])]), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v("Please select if you have a omnidirectional antenna (e.g. X-50) or a directional antenna (e.g. Yagi).")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.form.antennadirection),
      expression: "form.antennadirection",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "disabled": _vm.form.antennatype === 'OMNI',
      "min": "0",
      "max": "359",
      "placeholder": "0 - 359"
    },
    domProps: {
      "value": (_vm.form.antennadirection)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.antennadirection = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Other")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.form.power),
      expression: "form.power",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "max": "200",
      "placeholder": "0 - 200"
    },
    domProps: {
      "value": (_vm.form.power)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.power = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.form.antennalevel),
      expression: "form.antennalevel",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "max": "1000",
      "placeholder": "0 - 1000"
    },
    domProps: {
      "value": (_vm.form.antennalevel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.antennalevel = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _vm._m(3)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-lg-5 col-lg-offset-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.form.antennagain),
      expression: "form.antennagain",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "-50",
      "max": "80",
      "placeholder": "-50 - 80"
    },
    domProps: {
      "value": (_vm.form.antennagain)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.antennagain = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.form.identificationAddress),
      expression: "form.identificationAddress",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "max": "2097151",
      "placeholder": "0 - 2097151"
    },
    domProps: {
      "value": (_vm.form.identificationAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.identificationAddress = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _vm._m(5)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Timeslots")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tbody', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._m(6), _vm._v(" "), _c('tr', [_c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.timeslot),
      expression: "form.timeslot"
    }],
    staticClass: "timeslotCheckBox",
    attrs: {
      "type": "checkbox",
      "value": "0"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.timeslot) ? _vm._i(_vm.form.timeslot, "0") > -1 : (_vm.form.timeslot)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.form.timeslot,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "0",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.form.timeslot = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.form.timeslot = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.timeslot = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.timeslot),
      expression: "form.timeslot"
    }],
    staticClass: "timeslotCheckBox",
    attrs: {
      "type": "checkbox",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.timeslot) ? _vm._i(_vm.form.timeslot, "1") > -1 : (_vm.form.timeslot)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.form.timeslot,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.form.timeslot = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.form.timeslot = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.timeslot = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.timeslot),
      expression: "form.timeslot"
    }],
    staticClass: "timeslotCheckBox",
    attrs: {
      "type": "checkbox",
      "value": "2"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.timeslot) ? _vm._i(_vm.form.timeslot, "2") > -1 : (_vm.form.timeslot)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.form.timeslot,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "2",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.form.timeslot = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.form.timeslot = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.timeslot = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.timeslot),
      expression: "form.timeslot"
    }],
    staticClass: "timeslotCheckBox",
    attrs: {
      "type": "checkbox",
      "value": "3"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.timeslot) ? _vm._i(_vm.form.timeslot, "3") > -1 : (_vm.form.timeslot)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.form.timeslot,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "3",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.form.timeslot = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.form.timeslot = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.timeslot = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.timeslot),
      expression: "form.timeslot"
    }],
    staticClass: "timeslotCheckBox",
    attrs: {
      "type": "checkbox",
      "value": "4"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.timeslot) ? _vm._i(_vm.form.timeslot, "4") > -1 : (_vm.form.timeslot)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.form.timeslot,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "4",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.form.timeslot = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.form.timeslot = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.timeslot = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.timeslot),
      expression: "form.timeslot"
    }],
    staticClass: "timeslotCheckBox",
    attrs: {
      "type": "checkbox",
      "value": "5"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.timeslot) ? _vm._i(_vm.form.timeslot, "5") > -1 : (_vm.form.timeslot)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.form.timeslot,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "5",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.form.timeslot = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.form.timeslot = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.timeslot = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.timeslot),
      expression: "form.timeslot"
    }],
    staticClass: "timeslotCheckBox",
    attrs: {
      "type": "checkbox",
      "value": "6"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.timeslot) ? _vm._i(_vm.form.timeslot, "6") > -1 : (_vm.form.timeslot)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.form.timeslot,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "6",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.form.timeslot = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.form.timeslot = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.timeslot = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.timeslot),
      expression: "form.timeslot"
    }],
    staticClass: "timeslotCheckBox",
    attrs: {
      "type": "checkbox",
      "value": "7"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.timeslot) ? _vm._i(_vm.form.timeslot, "7") > -1 : (_vm.form.timeslot)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.form.timeslot,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "7",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.form.timeslot = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.form.timeslot = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.timeslot = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.timeslot),
      expression: "form.timeslot"
    }],
    staticClass: "timeslotCheckBox",
    attrs: {
      "type": "checkbox",
      "value": "8"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.timeslot) ? _vm._i(_vm.form.timeslot, "8") > -1 : (_vm.form.timeslot)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.form.timeslot,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "8",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.form.timeslot = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.form.timeslot = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.timeslot = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.timeslot),
      expression: "form.timeslot"
    }],
    staticClass: "timeslotCheckBox",
    attrs: {
      "type": "checkbox",
      "value": "9"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.timeslot) ? _vm._i(_vm.form.timeslot, "9") > -1 : (_vm.form.timeslot)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.form.timeslot,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "9",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.form.timeslot = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.form.timeslot = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.timeslot = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.timeslot),
      expression: "form.timeslot"
    }],
    staticClass: "timeslotCheckBox",
    attrs: {
      "type": "checkbox",
      "value": "A"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.timeslot) ? _vm._i(_vm.form.timeslot, "A") > -1 : (_vm.form.timeslot)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.form.timeslot,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "A",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.form.timeslot = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.form.timeslot = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.timeslot = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.timeslot),
      expression: "form.timeslot"
    }],
    staticClass: "timeslotCheckBox",
    attrs: {
      "type": "checkbox",
      "value": "B"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.timeslot) ? _vm._i(_vm.form.timeslot, "B") > -1 : (_vm.form.timeslot)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.form.timeslot,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "B",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.form.timeslot = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.form.timeslot = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.timeslot = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.timeslot),
      expression: "form.timeslot"
    }],
    staticClass: "timeslotCheckBox",
    attrs: {
      "type": "checkbox",
      "value": "C"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.timeslot) ? _vm._i(_vm.form.timeslot, "C") > -1 : (_vm.form.timeslot)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.form.timeslot,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "C",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.form.timeslot = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.form.timeslot = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.timeslot = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.timeslot),
      expression: "form.timeslot"
    }],
    staticClass: "timeslotCheckBox",
    attrs: {
      "type": "checkbox",
      "value": "D"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.timeslot) ? _vm._i(_vm.form.timeslot, "D") > -1 : (_vm.form.timeslot)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.form.timeslot,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "D",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.form.timeslot = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.form.timeslot = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.timeslot = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.timeslot),
      expression: "form.timeslot"
    }],
    staticClass: "timeslotCheckBox",
    attrs: {
      "type": "checkbox",
      "value": "E"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.timeslot) ? _vm._i(_vm.form.timeslot, "E") > -1 : (_vm.form.timeslot)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.form.timeslot,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "E",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.form.timeslot = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.form.timeslot = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.timeslot = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.timeslot),
      expression: "form.timeslot"
    }],
    staticClass: "timeslotCheckBox",
    attrs: {
      "type": "checkbox",
      "value": "F"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.timeslot) ? _vm._i(_vm.form.timeslot, "F") > -1 : (_vm.form.timeslot)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.form.timeslot,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "F",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.form.timeslot = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.form.timeslot = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.timeslot = $$c
        }
      }
    }
  })])])])]), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tAs all transmitters use the same frequency a time division multiplex access scheme is used.\n\t\t\t\t\t\t\t\tThere are 16 timeslots available.\n\t\t\t\t\t\t\t\tAssign the slots of this transmitter according to you surrounding transmitters in your neighborhood without overlapping timeslots that are assigned to more than one transmitter.\n\t\t\t\t\t\t\t\tYou can use the transmitter map to check already assigned timeslots of adjacent transmitters.\n\t\t\t\t\t\t\t\tIn case that you cannot fulfill your requirements, contact the adjacent transmitter owners and try to get an agreement.\n\t\t\t\t\t\t\t\tNormally four 4 or less timeslots per transmitter are more than enough.\n\t\t\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Owner")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.formData.users,
      "multiple": true,
      "close-on-select": false,
      "hide-selected": true,
      "clear-on-select": true,
      "placeholder": "Type to search",
      "label": "name",
      "track-by": "name"
    },
    model: {
      value: (_vm.form.owners),
      callback: function($$v) {
        _vm.form.owners = $$v
      },
      expression: "form.owners"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v("If you are an owner, you can change the parameters for this transmitter.")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-lg-10 col-lg-offset-2"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/transmitters"
    }
  }, [_c('button', {
    staticClass: "btn btn-default"
  }, [_vm._v("Abort")])])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('h2', [_vm._v("Information")]), _vm._v(" "), _c('ul', {
    staticClass: "list-group"
  }, [(_vm.form.device.type) ? _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Device")]), _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.form.device.type))])]) : _vm._e(), _vm._v(" "), (_vm.form.device.version) ? _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Version")]), _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.form.device.version))])]) : _vm._e(), _vm._v(" "), (_vm.form.address.ip_addr) ? _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("IP-Address")]), _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.form.address.ip_addr))])]) : _vm._e(), _vm._v(" "), (_vm.form.address.port) ? _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Port")]), _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.form.address.port))])]) : _vm._e(), _vm._v(" "), (_vm.form.connection.last || _vm.form.connection.since) ? _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Connection")]), _vm._v(" "), _c('ul', [(_vm.form.connection.last) ? _c('li', [_vm._v("Last: "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v(_vm._s(_vm.form.connection.last))])]) : _vm._e(), _vm._v(" "), (_vm.form.connection.since) ? _c('li', [_vm._v("Since: "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v(_vm._s(_vm.form.connection.since))])]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('p', [_vm._v("This table shows the registered paging transmitters, their online status and additional information. Personal transmitters have low output power and a very small coverage. Wide range transmitters are usually installed at elevated locations leading to a wide coverage area.")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v("Transmitters")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "help-block"
  }, [_c('b', [_vm._v("Antenna main beam direction")]), _vm._v(": Enter the antenna main beam direction in degrees according to \"True North\" (in German \"rechtweisend Nord\").")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "help-block"
  }, [_c('b', [_vm._v("Transmitter Power")]), _vm._v(": Enter the transmitter output power including your cable losses.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "help-block"
  }, [_c('b', [_vm._v("Antenna elevation over ground")]), _vm._v(": Enter the antenna elevation over ground; NOT over NN (!) in meters.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "help-block"
  }, [_c('b', [_vm._v("Antenna gain")]), _vm._v(": Enter the antenna gain in the main lobe direction for directional antennas and the average gain for omnidirectional antennas in dBi (dBi: Gain over isotropic radiator).")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "help-block"
  }, [_c('b', [_vm._v("Transmitter identification RIC")]), _vm._v(": Enter a RIC (default value is 1) which will be used to generate an artificial paging message containing the amateur radio callsign as given in this form.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("0")]), _vm._v(" "), _c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("2")]), _vm._v(" "), _c('td', [_vm._v("3")]), _vm._v(" "), _c('td', [_vm._v("4")]), _vm._v(" "), _c('td', [_vm._v("5")]), _vm._v(" "), _c('td', [_vm._v("6")]), _vm._v(" "), _c('td', [_vm._v("7")]), _vm._v(" "), _c('td', [_vm._v("8")]), _vm._v(" "), _c('td', [_vm._v("9")]), _vm._v(" "), _c('td', [_vm._v("A")]), _vm._v(" "), _c('td', [_vm._v("B")]), _vm._v(" "), _c('td', [_vm._v("C")]), _vm._v(" "), _c('td', [_vm._v("D")]), _vm._v(" "), _c('td', [_vm._v("E")]), _vm._v(" "), _c('td', [_vm._v("F")])])
}]}

/***/ }),
/* 621 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v("Impress")])]), _vm._v(" "), _c('p', [_vm._v("Angaben gemäß § 5 TMG:")]), _vm._v(" "), _c('p', [_vm._v("Ralf Wilke"), _c('br'), _vm._v("\n\t\t\t\tAmateurfunkgruppe an der RWTH Aachen"), _c('br'), _vm._v("\n\t\t\t\tInstitut für Hochfrequenztechnik"), _c('br'), _vm._v("\n\t\t\t\t52074 Aachen\n\t\t\t")]), _vm._v(" "), _c('h2', [_vm._v("Kontakt:")]), _vm._v(" "), _c('table', [_c('tr', [_c('td', [_vm._v("Telefon:")]), _vm._v(" "), _c('td', [_vm._v("+49 (0) 241 80 27959")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("E-Mail:")]), _vm._v(" "), _c('td', [_vm._v("rwth-afu@online.de")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Webseite:")]), _vm._v(" "), _c('td', [_c('a', {
    attrs: {
      "href": "https://www.afu.rwth-aachen.de"
    }
  }, [_vm._v("www.afu.rwth-aachen.de")])])])]), _vm._v(" "), _c('p', [_vm._v("Quelle: "), _c('em', [_c('a', {
    attrs: {
      "rel": "nofollow",
      "href": "http://www.e-recht24.de"
    }
  }, [_vm._v("http://www.e-recht24.de")])])]), _vm._v(" "), _c('h2', [_vm._v("Haftungsausschluss (Disclaimer)")]), _vm._v(" "), _c('h3', [_vm._v("Haftung für Inhalte")]), _vm._v(" "), _c('p', [_vm._v("Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.")]), _vm._v(" "), _c('h3', [_vm._v("Haftung für Links")]), _vm._v(" "), _c('p', [_vm._v("Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.")]), _vm._v(" "), _c('h3', [_vm._v("Urheberrecht")]), _vm._v(" "), _c('p', [_vm._v("Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.")]), _vm._v(" "), _c('script', {
    attrs: {
      "type": "application/ld+json"
    }
  }, [_vm._v("\n\t\t\t{\n\t\t\t\t\"@context\": \"http://schema.org\",\n\t\t\t\t\"@type\": \"Organization\",\n\t\t\t\t\"url\": \"https://www.afu.rwth-aachen.de\",\n\t\t\t\t\"contactPoint\": [{\n\t\t\t\t\t\"@type\": \"ContactPoint\",\n\t\t\t\t\t\"telephone\": \"+49-241-80-27959\",\n\t\t\t\t\t\"contactType\": \"technical support\"\n\t\t\t\t}]\n\t\t\t}\n\t\t\t")])])])])
}]}

/***/ }),
/* 622 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('app-navigation'), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 623 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-9"
  }, [_c('h2', [_vm._v("All Transmitters\n\t\t\t\t"), _c('i', {
    staticClass: "fa fa-refresh fa-fw",
    class: {
      'fa-spin': _vm.running
    },
    on: {
      "click": _vm.loadData
    }
  })]), _vm._v(" "), _c('info-error', {
    attrs: {
      "message": _vm.errorMessage
    }
  }), _vm._v(" "), (_vm.table.rows) ? _c('tablegrid', {
    attrs: {
      "columns": _vm.table.columns,
      "data": _vm.table.rows,
      "mail-action": _vm.mailToOwner,
      "edit-action": _vm.editElement,
      "delete-action": _vm.deleteElement
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "actions well"
  }, [(this.$store.getters.user.admin) ? [_c('legend', [_vm._v("Actions")]), _vm._v(" "), _c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/transmitters/new"
    }
  }, [_vm._v("New Transmitter")])], 1), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "linklike",
    on: {
      "click": _vm.mailToAll
    }
  }, [_vm._v("Send a mail to all owners")])])]), _vm._v(" "), _c('br')] : _vm._e(), _vm._v(" "), (_vm.table.rows) ? [_c('legend', [_vm._v("Statistics")]), _vm._v(" "), _c('ul', {
    staticClass: "list-group"
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Total Transmitters")]), _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.statTotal))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('chart-online-offline', {
    attrs: {
      "chartData": _vm.chartData
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('chart-transmitter-types', {
    attrs: {
      "chartData": _vm.chartDataDeviceTypes
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.widerangeOnly),
      expression: "settings.widerangeOnly"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.settings.widerangeOnly) ? _vm._i(_vm.settings.widerangeOnly, null) > -1 : (_vm.settings.widerangeOnly)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.settings.widerangeOnly,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.settings.widerangeOnly = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.settings.widerangeOnly = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.settings.widerangeOnly = $$c
        }
      }
    }
  }), _vm._v(" Show Widerange-transmitter only")])])] : _vm._e()], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v("Transmitters")])])])])
}]}

/***/ }),
/* 624 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-9"
  }, [_c('form', {
    staticClass: "form-horizontal well"
  }, [_c('fieldset', [(!this.$route.params.id) ? _c('legend', [_vm._v("New Rubric")]) : _vm._e(), _vm._v(" "), (this.$route.params.id) ? _c('legend', [_vm._v("Edit Rubric")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.name),
      expression: "form.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.name = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.editing) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("Changing this name will create a duplication and "), _c('i', [_vm._v("not")]), _vm._v(" change the element's name.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Label")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.label),
      expression: "form.label"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.label)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.label = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Number")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.form.number),
      expression: "form.number",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "99",
      "placeholder": "1 - 99"
    },
    domProps: {
      "value": (_vm.form.number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.number = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Transmitter Groups")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.formData.transmittergroups,
      "multiple": true,
      "close-on-select": false,
      "hide-selected": true,
      "clear-on-select": true,
      "placeholder": "Type to search",
      "label": "name",
      "track-by": "name"
    },
    model: {
      value: (_vm.form.transmittergroups),
      callback: function($$v) {
        _vm.form.transmittergroups = $$v
      },
      expression: "form.transmittergroups"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Owner")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.formData.users,
      "multiple": true,
      "close-on-select": false,
      "hide-selected": true,
      "clear-on-select": true,
      "placeholder": "Type to search",
      "label": "name",
      "track-by": "name"
    },
    model: {
      value: (_vm.form.owners),
      callback: function($$v) {
        _vm.form.owners = $$v
      },
      expression: "form.owners"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-lg-10 col-lg-offset-2"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/rubrics"
    }
  }, [_c('button', {
    staticClass: "btn btn-default"
  }, [_vm._v("Abort")])])], 1)])])])]), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v("Rubrics")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-3"
  }, [_c('h2', [_vm._v("Information")]), _vm._v(" "), _c('p', [_vm._v("Rubrics are a Skyper based invention allowing to send news sorted into chategories (the rubrics). Assign the number with care and contact "), _c('code', [_vm._v("rwth-afu [at] online.de")]), _vm._v(" in case of doubt. Be aware that the number of rubrics is limited netwide to 99.")])])
}]}

/***/ }),
/* 625 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.message) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_c('h4', [_vm._v("Error")]), _vm._v("\n\t" + _vm._s(_vm.message) + "\n")]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 626 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('footer', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('ul', {
    staticClass: "list-unstyled"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled"
  }), _vm._v(" "), _c('p', [_c('b', [_vm._v("Versions:")]), _vm._v(" Core: " + _vm._s(_vm.version.core) + " / Web: " + _vm._s(_vm.version.web) + " / "), _c('router-link', {
    attrs: {
      "to": "/version"
    }
  }, [_vm._v("Check")])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("dpn.freeband.digital")])])
}]}

/***/ }),
/* 627 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-9"
  }, [_c('form', {
    staticClass: "form-horizontal well"
  }, [_c('fieldset', [(!this.$route.params.id) ? _c('legend', [_vm._v("New Transmitter Group")]) : _vm._e(), _vm._v(" "), (this.$route.params.id) ? _c('legend', [_vm._v("Edit Transmitter Group")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.name),
      expression: "form.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.name = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.editing) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("Changing this name will create a duplication and "), _c('i', [_vm._v("not")]), _vm._v(" change the element's name.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.description),
      expression: "form.description"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.description = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Transmitters")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.formData.transmitters,
      "multiple": true,
      "close-on-select": false,
      "hide-selected": true,
      "clear-on-select": true,
      "placeholder": "Type to search",
      "label": "name",
      "track-by": "name"
    },
    model: {
      value: (_vm.form.transmitters),
      callback: function($$v) {
        _vm.form.transmitters = $$v
      },
      expression: "form.transmitters"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Owner")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.formData.users,
      "multiple": true,
      "close-on-select": false,
      "hide-selected": true,
      "clear-on-select": true,
      "placeholder": "Type to search",
      "label": "name",
      "track-by": "name"
    },
    model: {
      value: (_vm.form.owners),
      callback: function($$v) {
        _vm.form.owners = $$v
      },
      expression: "form.owners"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-lg-10 col-lg-offset-2"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/transmitters/groups"
    }
  }, [_c('button', {
    staticClass: "btn btn-default"
  }, [_vm._v("Abort")])])], 1)])])])]), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v("Transmitter Groups")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-3"
  }, [_c('h2', [_vm._v("Information")]), _vm._v(" "), _c('p', [_vm._v("A transmitter group combines one of several transmitters to a logical entity. The group all contains all registered transmitters. Other groups are assigned by their coverage area.")])])
}]}

/***/ }),
/* 628 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-9"
  }, [_c('form', {
    staticClass: "form-horizontal well"
  }, [_c('fieldset', [(!this.$route.params.id) ? _c('legend', [_vm._v("New Node")]) : _vm._e(), _vm._v(" "), (this.$route.params.id) ? _c('legend', [_vm._v("Edit Node")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.name),
      expression: "form.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.name = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.editing) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("Changing this name will create a duplication and "), _c('i', [_vm._v("not")]), _vm._v(" change the element's name.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Latitude / Longitude")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.form.latitude.value),
      expression: "form.latitude.value",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "max": "90",
      "placeholder": "0 - 90"
    },
    domProps: {
      "value": (_vm.form.latitude.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.latitude.value = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.form.latitude.orientation),
      expression: "form.latitude.orientation",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.form.latitude.orientation = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("North")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "-1"
    }
  }, [_vm._v("South")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.form.longitude.value),
      expression: "form.longitude.value",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "max": "180",
      "placeholder": "0 - 180"
    },
    domProps: {
      "value": (_vm.form.longitude.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.longitude.value = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.form.longitude.orientation),
      expression: "form.longitude.orientation",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.form.longitude.orientation = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("East")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "-1"
    }
  }, [_vm._v("West")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Owner")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.formData.users,
      "multiple": true,
      "close-on-select": false,
      "hide-selected": true,
      "clear-on-select": true,
      "placeholder": "Type to search",
      "label": "name",
      "track-by": "name"
    },
    model: {
      value: (_vm.form.owners),
      callback: function($$v) {
        _vm.form.owners = $$v
      },
      expression: "form.owners"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Status")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.status),
      expression: "form.status"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.form.status = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "ONLINE"
    }
  }, [_vm._v("Online")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SUSPENDED"
    }
  }, [_vm._v("Suspended")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-lg-10 col-lg-offset-2"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/nodes"
    }
  }, [_c('button', {
    staticClass: "btn btn-default"
  }, [_vm._v("Abort")])])], 1)])])])]), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v("Nodes")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-3"
  }, [_c('h2', [_vm._v("Information")]), _vm._v(" "), _c('p', [_vm._v("This table shows the registered DAPNET Core nodes and is mostly for SysOp information.")])])
}]}

/***/ }),
/* 629 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.editAction) ? _c('button', {
    staticClass: "btn btn-info btn-xs",
    on: {
      "click": function($event) {
        _vm.editAction(_vm.element)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "title": "Edit"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.deleteAction) ? _c('button', {
    staticClass: "btn btn-primary btn-xs",
    on: {
      "click": function($event) {
        _vm.deleteAction(_vm.element)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash",
    attrs: {
      "title": "Delete"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.mailAction) ? _c('button', {
    staticClass: "btn btn-default btn-xs",
    on: {
      "click": function($event) {
        _vm.mailAction(_vm.element)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope",
    attrs: {
      "title": "Send Email"
    }
  })]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 630 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-9"
  }, [_c('form', {
    staticClass: "form-horizontal well"
  }, [_c('fieldset', [_c('legend', [_vm._v("New Call")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Message")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.message),
      expression: "form.message"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "2",
      "maxlength": "80"
    },
    domProps: {
      "value": (_vm.form.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.message = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.messageCharsRemaining) + " / 80 characters remaining."), _c('br'), _vm._v("Enter your paging text. Your callsign is added automatically.")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Callsigns")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.formData.callsigns,
      "multiple": true,
      "close-on-select": false,
      "hide-selected": true,
      "clear-on-select": true,
      "placeholder": "Type to search",
      "label": "name",
      "track-by": "name"
    },
    model: {
      value: (_vm.form.callsigns),
      callback: function($$v) {
        _vm.form.callsigns = $$v
      },
      expression: "form.callsigns"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v("Select one or multiple callsigns you what to send the message to.")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Transmitter Groups")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.formData.transmittergroups,
      "multiple": true,
      "close-on-select": false,
      "hide-selected": true,
      "clear-on-select": true,
      "placeholder": "Type to search",
      "label": "name",
      "track-by": "name"
    },
    model: {
      value: (_vm.form.transmittergroups),
      callback: function($$v) {
        _vm.form.transmittergroups = $$v
      },
      expression: "form.transmittergroups"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v("Select a logical transmitter group that should broadcast your message. Default is all transmitters, but if you know the approximate location of the receiver you might limit the transmitters used for your paging to a certain area. This reduces the load on the transmitters.")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Emergency?")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10 checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.emergency),
      expression: "form.emergency"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.emergency) ? _vm._i(_vm.form.emergency, null) > -1 : (_vm.form.emergency)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.form.emergency,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.form.emergency = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.form.emergency = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.emergency = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v("In case you want your message to be delivered as soon as possible, check this box. No harmful things will happen, the DAPNET will just process your message with maximum priority. Please make a fair use of this feature.")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-lg-10 col-lg-offset-2"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/calls"
    }
  }, [_c('button', {
    staticClass: "btn btn-default"
  }, [_vm._v("Abort")])])], 1)])])])]), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v("Calls")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-3"
  }, [_c('h2', [_vm._v("Information")]), _vm._v(" "), _c('p', [_vm._v("Here your recent paging calls are displayed.")])])
}]}

/***/ }),
/* 631 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-9"
  }, [_c('h2', [_vm._v("All Users\n\t\t\t\t"), _c('i', {
    staticClass: "fa fa-refresh fa-fw",
    class: {
      'fa-spin': _vm.running
    },
    on: {
      "click": _vm.loadData
    }
  })]), _vm._v(" "), _c('info-error', {
    attrs: {
      "message": _vm.errorMessage
    }
  }), _vm._v(" "), (_vm.table.rows) ? _c('tablegrid', {
    attrs: {
      "columns": _vm.table.columns,
      "data": _vm.table.rows,
      "mail-action": _vm.mailToOwner,
      "edit-action": _vm.editElement,
      "delete-action": _vm.deleteElement
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "actions well"
  }, [(this.$store.getters.user.admin) ? [_c('legend', [_vm._v("Actions")]), _vm._v(" "), _c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/users/new"
    }
  }, [_vm._v("New User")])], 1), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "linklike",
    on: {
      "click": _vm.mailToAll
    }
  }, [_vm._v("Send a mail to all owners")])])]), _vm._v(" "), _c('br')] : _vm._e(), _vm._v(" "), (_vm.table.rows) ? [_c('legend', [_vm._v("Statistics")]), _vm._v(" "), _c('ul', {
    staticClass: "list-group"
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Total Administrators")]), _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.statAdministrators))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Total Users")]), _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.statTotal))])])])] : _vm._e()], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v("Users")])])])])
}]}

/***/ }),
/* 632 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_vm._m(0), _vm._v(" "), _c('p', [_vm._v("If you see this page, something went wrong.")]), _vm._v(" "), _c('div', [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "30%",
      "viewBox": "0 0 64 64",
      "enable-background": "new 0 0 64 64"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "32",
      "cy": "32",
      "r": "30",
      "fill": "#ffdd67"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "fill": "#ff717f"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "52.8",
      "cy": "37.1",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "11.2",
      "cy": "37.1",
      "r": "8"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "fill": "#917524"
    }
  }, [_c('path', {
    attrs: {
      "d": "m54.6 20.6c-2.7-3.3-6.7-5.1-11-5.1-.6 0-.7-2.2 0-2.2 4.9 0 9.5 2.1 12.7 5.9.5.6-1.3 1.9-1.7 1.4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m20.3 15.4c-4.2 0-8.3 1.9-11 5.1-.4.5-2.1-.8-1.7-1.4 3.1-3.8 7.8-5.9 12.7-5.9.7 0 .6 2.2 0 2.2"
    }
  })]), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "32",
      "cy": "49.5",
      "r": "4.5",
      "fill": "#664e27"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m29.5 29.1c0 5-4 9-9 9-5 0-9-4-9-9 0-5 4-9 9-9 5 0 9 4.1 9 9",
      "fill": "#fff"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "20.5",
      "cy": "29.1",
      "r": "4.5",
      "fill": "#664e27"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m52.5 29.1c0 5-4 9-9 9-5 0-9-4-9-9 0-5 4-9 9-9 5 0 9 4.1 9 9",
      "fill": "#fff"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "43.5",
      "cy": "29.1",
      "r": "4.5",
      "fill": "#664e27"
    }
  })])]), _vm._v(" "), _vm._m(1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v("Logout")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Emoji provided for free by "), _c('a', {
    attrs: {
      "href": "http://emojione.com",
      "target": "_blank"
    }
  }, [_vm._v("EmojiOne")]), _vm._v(".")])
}]}

/***/ }),
/* 633 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('info-error', {
    attrs: {
      "message": _vm.errorMessage
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.displayData) ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.displayData)
    }
  }) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v("Version Check")])])])])
}]}

/***/ }),
/* 634 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "30%",
      "viewBox": "0 0 64 64",
      "enable-background": "new 0 0 64 64"
    }
  }, [_c('path', {
    attrs: {
      "d": "M32,2c-13.4,0-20.8,8.5-20.8,19.7v22.7h41.6V21.7c0-16.7-11.2-16.4-11.2-16.4S40.7,2,32,2z",
      "fill": "#ffb300"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m51.1 36.7c-5.2-4.7-19 4.3-19.1 4.3-.1-.1-13.9-9-19.1-4.3-4.8 4.4.8 25.3.8 25.3h36.5c.1 0 5.7-20.9.9-25.3",
      "fill": "#c28fef"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m17.7 33.2c0 0-3.1-.2-3.9-4.7-.6-3.5 1.5-4.6 1.5-4.6 7.7-3.9 19.3-14.3 19.3-14.3s5.4 5.4 11.6 8.9c0 0 2.4 0 3.1 3.8.8 4.5-2.2 5.8-2.2 5.8 1.2 6.8-6.5 16.5-12 17.5-5.5.9-16.2-5.6-17.4-12.4",
      "fill": "#ffdd67"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "fill": "#937237"
    }
  }, [_c('path', {
    attrs: {
      "d": "m28.6 40.9c-.1 0-.2-.1-.2-.2-.1-.7 2.2-2.7 5.2-3.2 3.1-.5 5.8.5 6 1.2 0 .1 0 .2-.1.3 0 0-2.6-1.1-5.7-.5-3 .5-5.2 2.4-5.2 2.4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m18.1 23c-.1-.1-.1-.1-.1-.2 0-.6 2-1.5 4.6-1.6 2.6-.2 4.8.4 4.8 1.1 0 .1 0 .2-.1.2 0 0-2.1-.4-4.6-.2-2.6.1-4.6.7-4.6.7"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m42.8 16.7c.1-.1.1-.2 0-.2-.2-.6-2.5-.5-4.9.4-2.4.9-4.1 2.4-3.9 2.9 0 .1.1.1.2.2 0 0 1.7-1.2 4.1-2.1 2.4-1 4.5-1.2 4.5-1.2"
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m37 34.4c.2 1-2.8 1.8-3.5 2-.7.1-3.8.3-3.9-.7-.1-.1 7.3-1.8 7.4-1.3",
      "fill": "#eba352"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m27.1 29.8c.9-.2.4-2.4.4-2.4-3.7-5.5-8.9-.7-8.9-.7-2.1 1.4 1.8 4.1 2.3 4.1 2.6.3 6.2-1 6.2-1",
      "fill": "#f5f5f5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m26 27.1c.3 1.6-.8 3-2.3 3.3-1.6.3-3-.8-3.3-2.3-.3-1.6.8-3 2.3-3.3 1.6-.3 3.1.8 3.3 2.3",
      "fill": "#664e27"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "fill": "#231f20"
    }
  }, [_c('path', {
    attrs: {
      "d": "m24.2 27.5c.1.5-.3 1.1-.8 1.2-.5.1-1.1-.3-1.2-.8-.1-.5.3-1.1.8-1.2.6-.1 1.1.2 1.2.8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m28.4 28.1c-.9-.8-1.7-1.5-2.7-2-.9-.5-1.9-.7-3-.6-1 .1-2 .5-3.1.9-.5.2-1.1.4-1.7.5-.6.1-1.3.2-1.7-.2.6.1 1.1-.1 1.6-.3.5-.2 1-.5 1.5-.8 1-.6 2.1-1.1 3.4-1.2.6 0 1.3 0 1.9.2.6.2 1.2.5 1.7.8.8.7 1.6 1.7 2.1 2.7"
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m37.1 28c-.9.2-1.1-2.1-1.1-2.1 1.6-6.4 8.2-3.7 8.2-3.7 2.5.6-.3 4.4-.8 4.7-2.4 1.1-6.3 1.1-6.3 1.1",
      "fill": "#f5f5f5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m42.9 24.2c.3 1.6-.8 3-2.3 3.3-1.6.3-3-.8-3.3-2.3-.3-1.6.8-3 2.3-3.3 1.6-.3 3 .7 3.3 2.3",
      "fill": "#664e27"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "fill": "#231f20"
    }
  }, [_c('path', {
    attrs: {
      "d": "m41.1 24.5c.1.5-.3 1.1-.8 1.2-.5.1-1.1-.3-1.2-.8-.1-.5.3-1.1.8-1.2.6-.1 1.1.3 1.2.8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m35.4 26.9c.1-1.1.5-2.3 1.2-3.3.3-.5.8-1 1.3-1.3.5-.4 1.1-.6 1.7-.8 1.2-.3 2.4-.2 3.6 0 .6.1 1.1.2 1.7.3.5.1 1.1.1 1.6-.2-.3.5-1 .7-1.6.8-.6.1-1.2.1-1.7.1-1.1 0-2.2 0-3.2.2-1 .2-1.9.8-2.6 1.6-.9.6-1.4 1.6-2 2.6"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m16.6 49.9l-.8 12.1h11.1l-1.3-12.8h-.8c-.1-.7-.2-1.4-1.1-3.2-1.5-3.3-7.4-2.1-9.7-1.5l-2 5.5c3.6.4 4.6-.1 4.6-.1",
      "opacity": ".2"
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m17.4 50.4v-1.1c0 0-10.2 2.1-14-1.4-4.8-4.5 3.4-2 9.6-3.5 2.2-.6 8.1-1.7 9.7 1.5 1.7 3.5 1.3 4.5 1.3 4.5h-6.6",
      "fill": "#ffdd67"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#c28fef",
      "d": "m16.3 62l.8-12.3h7.7l1.1 12.3z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m47.4 49.9l.8 12.1h-11.1l1.3-12.8h.8c.1-.7.2-1.4 1.1-3.2 1.5-3.3 7.4-2.1 9.7-1.5l2 5.6c-3.6.3-4.6-.2-4.6-.2",
      "opacity": ".2",
      "fill": "#231f20"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m46.6 50.4v-1.1c0 0 10.2 2.1 14-1.4 4.8-4.5-3.4-2-9.6-3.5-2.2-.6-8.1-1.7-9.7 1.5-1.7 3.5-1.3 4.5-1.3 4.5h6.6",
      "fill": "#ffdd67"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#c28fef",
      "d": "m47.7 62l-.8-12.3h-7.7l-1.1 12.3z"
    }
  })])]), _vm._v(" "), _vm._m(1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v("Error 404 - Not Found")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Emoji provided for free by "), _c('a', {
    attrs: {
      "href": "http://emojione.com",
      "target": "_blank"
    }
  }, [_vm._v("EmojiOne")]), _vm._v(".")])
}]}

/***/ }),
/* 635 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-9"
  }, [_c('form', {
    staticClass: "form-horizontal well"
  }, [_c('fieldset', [(!this.$route.params.id) ? _c('legend', [_vm._v("New User")]) : _vm._e(), _vm._v(" "), (this.$route.params.id) ? _c('legend', [_vm._v("Edit User")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.name),
      expression: "form.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.name = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.editing) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("Changing this name will create a duplication and "), _c('i', [_vm._v("not")]), _vm._v(" change the element's name.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Password")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.password),
      expression: "form.password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.form.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.password = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.passwordGenerated) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("This is the newly generated password: "), _c('code', [_vm._v(_vm._s(_vm.passwordGenerated))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-1"
  }, [_c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "type": "button",
      "title": "Generate new random password",
      "data-toggle": "tooltip",
      "data-placement": "bottom"
    },
    on: {
      "click": _vm.generatePassword
    }
  }, [_c('i', {
    staticClass: "fa fa-repeat"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.email),
      expression: "form.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Admin?")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10 checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.admin),
      expression: "form.admin"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.admin) ? _vm._i(_vm.form.admin, null) > -1 : (_vm.form.admin)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.form.admin,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.form.admin = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.form.admin = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.admin = $$c
        }
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-lg-10 col-lg-offset-2"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/users"
    }
  }, [_c('button', {
    staticClass: "btn btn-default"
  }, [_vm._v("Abort")])])], 1)])])])]), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v("Users")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-3"
  }, [_c('h2', [_vm._v("Information")]), _vm._v(" "), _c('p', [_vm._v("This table shows the registered users and their detail information.")])])
}]}

/***/ }),
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */
/***/ (function(module, exports) {

module.exports = {"center":[51,10],"zoom":5}

/***/ }),
/* 642 */
/***/ (function(module, exports) {

module.exports = "Bitte beantragen Sie Benutzername und Passwort per Mail via <code>kontakt@freeband.digital</code>.<br /><br />"

/***/ }),
/* 643 */
/***/ (function(module, exports) {

module.exports = {"api":"http://144.76.222.20:8080","update":"http://www.hampager.de/dapnet-update/update.php","hamnetDb":"http://www.hampager.de/dapnet-update/callsignLocation.php","map":"https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"}

/***/ }),
/* 644 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
]),[289]);


// WEBPACK FOOTER //
// assets/js/app.67dae96f4f988765a009.js